import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, NoItemsCard, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Radio, RadioGroup, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, Spinner } from "@heroui/react"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funValidateNoInput, GetLoginCredentialDb, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faCircleArrowUp, faDownload, faExclamationTriangle, faExplosion, faFile, faFileExcel, faGem, faPlus, faPrint, faRefresh, faSave, faSearchPlus, faSquareXmark, faTemperatureEmpty, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { DataGrid, useGridApiRef, GridCellParams, GridPagination, useGridApiContext, GridColumnMenu } from "@mui/x-data-grid"
import { calculateTotal, funCheckNumber, funNormalizeInput, scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"
import { Box, Drawer, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material"
import { setRedirectLink } from "../../state/accountSlice"
import { addDays } from "date-fns"
import { resetDetailParams, setInvoiceDetail } from "../../state/invoiceEntrySlice"
import { setModSettingData } from "../../state/memoEntrySlice"
import ReportViewer from "../report/ReportViewer"
import { enum_Report_Type } from "../report/ReportUtility"
import { scrollInfo } from "framer-motion"
import * as XLSX from 'xlsx';
import { saveAs } from "file-saver";
import { useModalToast } from "../../components/modalToast/ModalToastContext"
import newStyled from "@emotion/styled"
import { parse } from "@fortawesome/fontawesome-svg-core"
import ExportDetailEntry from "./ExportDetailEntry"

const RowsField = {
    detailId: "detailId",
    id: "id",
    itemCode: "itemCode",
    itemName: "itemName",
    itemDetail: "itemDetail",
    shapeName: "shapeName",
    shapeCode: "shapeCode",
    pktNo: "pktNo",
    lotNo: "lotNo",
    sPktNo: "sPktNo",
    sLotNo: "sLotNo",
    purityName: "purityName",
    purityCode: "purityCode",
    colorName: "colorName",
    colorCode: "colorCode",
    sizeName: "sizeName",
    sizeCode: "sizeCode",
    lwRatio: "lwRatio",
    objLwRatio: "objLwRatio",
    rate: "rate",
    amount: "amount",
    dRate: "dRate",
    dAmount: "dAmount",
    convRate: "convRate",
    pcs: "pcs",
    weight: "weight",
    reportNo: "reportNo",
    lab: "lab",
    discPer: "discPer",
    discAmt: "discAmt",
    discAmtD: "discAmtD",
    stPer: "stPer",
    stAmt: "stAmt",
    astPer: "astPer",
    astAmt: "astAmt",
    netAmt: "netAmt",
    netAmtD: "netAmtD",
    oldWeight: "oldWeight",
    oldPcs: "oldPcs",
    bPcs: "bPcs",
    bWeight: "bWeight",
    fancyColor: "fancyColor"
}

export const InputCell = ({
    row,
    input_id,
    input_type,
    is_readonly,
    holder_text,
    is_required,
    //is_disabled,
    variant,
    isStPerDisable,
    color,
    handleInputChange,
    hanldeBlur,
    handleKeyDown
}) => {
    const [localValue, setLocalValue] = useState(row[input_id] ?? "");

    useEffect(() => {
        setLocalValue(input_id == "astPer" || input_id == "astAmt"
            ? isStPerDisable
                ? "0"
                : row[input_id]
            : row[input_id]
        );
    }, [row[input_id]]);

    const onBlur = (e) => {
        const syntheticEvent = {
            ...e,
            target: {
                ...e.target,
                value: localValue,
                id: RowsField[input_id],
            },
        };

        handleInputChange(row.id, syntheticEvent, RowsField[input_id]);
        setTimeout(() => { hanldeBlur(row.id - 1, syntheticEvent, RowsField[input_id]) }, 0)
    };
    return (
        <input
            required={is_required}
            id={RowsField[input_id]}
            type={input_type}
            data-grid-input="true"
            readOnly={is_readonly}
            disabled={
                input_id === "astPer"
                    ? isStPerDisable
                    : input_id === RowsField.reportNo ||
                        input_id === RowsField.lotNo ||
                        input_id === RowsField.pktNo
                        ? is_readonly
                        : false
            }
            placeholder={holder_text}
            value={localValue}
            onChange={(e) => setLocalValue(e.target.value)}
            onBlur={onBlur}
            onKeyDown={(e) => {
                if (e.key === " " && input_type == "text") {
                    e.stopPropagation();
                }
            }}
            onFocus={(e) => e.target.select()}
            className={`
     mt-1 text-xs border rounded px-1 py-2
    ${input_type === "number" ? "text-right" : ""}
    ${is_readonly ? "bg-gray-100 cursor-not-allowed" : ""}
    ${[RowsField.discPer, RowsField.stPer, RowsField.astPer].includes(input_id) ? "w-16" : input_id == RowsField.itemDetail ? "w-full" : "w-24"}
  `}
        />


    );
};
const CreateInvoiceMaster = () => {
    const { compCode, compState, isMultipleCompany, yearId, startDate, endDate } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.invoiceEntry)
    const { user, token } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const { btype, trdtype, ptype } = useParams();
    const [selectedGridRowId, setSelectedGridRowId] = useState()
    const [modSettingParams, setModSettingParams] = useState()
    const [entryLabel, setEntryLabel] = useState("")
    const [selBillType, setSelBillType] = useState("")
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selPktType, setSelPktType] = useState("")
    const [naviCode, setnaviCode] = useState("")
    const [mixStockParams, setMixStockParams] = useState("")
    const [isStPerDisable, setIsStPerDisable] = useState(false)
    const [brokPer, setBrokPer] = useState(0)
    const [tdsPer, setTdsPer] = useState(0)
    const [tdsAcId, setTdsAcId] = useState(0)
    const [isWithBill, setIsWithBill] = useState(false)
    const [isRefId, setIsRefId] = useState(false)
    const [updateFlag, setUpdateFlag] = useState(0)
    const [CurrencySetting, setCurrencySetting] = useState("")
    const dispatch = useDispatch();
    const gridContainerRef = useRef(null)
    const [submitBtnId, setSubmitBtnId] = useState("")
    const [selModName, setSelModName] = useState("")
    const [openDrawer, setOpenDrawer] = useState(false)
    const fileInputRef = useRef(null)
    const [isDollarInvoice, setIsDollarInvoice] = useState("1")
    const [mktLotNo, setMktLotNo] = useState("0")
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [selConvRate, setSelConvRate] = useState("")
    const [selDiscPer, setSelDiscPer] = useState("")
    const [selDRate, setSelDRate] = useState("")
    const [isExcelImport, setIsExcelImport] = useState(false)
    const [isImportByStockId, setIsImportByStockId] = useState(false)
    const [ExcelColMap, setExcelColMap] = useState([])
    const [searchText, setSearchText] = useState("")
    const [excelData, setExcelData] = useState([])
    const [stockIdSplitter, setStockIdSplitter] = useState("-")
    const [isSameItem, setIsSameItem] = useState(false)
    const [isExportDetails, setIsExportDetails] = useState(false)
    const { show } = useModalToast();

    const [JvTrnData, setJvTrnData] = useState({
        trnNo: 0,
        tdsJvTrnNo: 0,
        tcsJvTrnNo: 0,
        excJvTrnNo: 0,
        excSedJvTrnNo: 0,
        excAedJvTrnNo: 0,
        bTrnNo: 0
    })

    const CUSTOM_ENUM_TRADE_TYPE = useMemo(() => {
        if (selBillType == 'S')
            return [...ENUM_TRADE_TYPE, { t_type: "EXP" }]
        else if (selBillType == 'P')
            return [...ENUM_TRADE_TYPE, { t_type: "IMP" }]
        else
            return ENUM_TRADE_TYPE
    }, [selBillType])

    console.log(CUSTOM_ENUM_TRADE_TYPE, "dsf", selBillType)
    const onSuccessMastData = (data) => {
        if (data && Object.keys(data).length > 0) {
            if (data.bookMaster.length > 0) {

                setFormData({ ...formData, [formField.bookId]: data.bookMaster[0].Party_Id })
                funGenVouNo(data.bookMaster[0].Party_Id, isNewEntry)
                if (selBillType == 'S')
                    funGenBillNo(data.bookMaster[0].Party_Id, isNewEntry)

            }
        }

    }

    const submitLockRef = useRef(false);//
    const minAllowedDate = dayjs(startDate)
    const maxAllowedDate = dayjs(endDate)

    const { isPending: isLoadingData, isError: isErrorMastData, data: masterData = [], mutate: filterMatserData } = usePost({
        url: apiRoute.memoEntry.entryMasterData,
        queryKey: "fetchInvoiceMasterData",
        onSuccessTasks: onSuccessMastData

    })

    const getPartymapingData = (mapType, partyId) => {
        let MapId = ""
        let BrokerPer = 0
        if (masterData && masterData?.mapingMaster && masterData?.mapingMaster.length > 0) {
            const filData = masterData.mapingMaster.filter((ele) => ele.MapType == mapType && ele.PartyId == partyId)
            if (filData && filData.length > 0) {
                MapId = filData[0].TypeId
                BrokerPer = filData[0].BroPer
            }
        }
        return { MapId, BrokerPer }
    }
    const onSuccessChkPktLotNo = (data, index, dataRows) => {
        if (data && data.length > 0) {
            // let total_pkt = data[0].count
            //let total_lot = data[1].count
            if (data[0].count > 0) {
                const newRows = [...dataRows]
                let msg = ""
                // if (!isExcelImport) {
                newRows[index][RowsField.pktNo] = ''
                newRows[index][RowsField.lotNo] = ''
                setRows(newRows)
                //}
                show(<div>Duplicate Lot No. and Pkt No. not allowed
                    <div className="text-yellow-600  bg-yellow-50  p-2 m-1 text-xs ">The combination of Lot No. and Pkt No. must be unique.</div>
                </div>)

            }
        }
    }
    const { isPending: isLoadingDupPktList, data: dupPktList = [], mutate: funGetDupPktList } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getDupPktList,
        queryKey: "funDupPktStockList",
    })
    const { isPending: isPendingStkPos, data: stkWithPosData = [], mutate: findStockWithPosition } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.findStokeWithPosition,
        queryKey: "fetchStockwithPositionData",
    })
    const { data: dupLotPktNo = [], mutate: funChkPktLotNo } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.checkLotPktNo,
        queryKey: "checkLotNoPktData",
        //onSuccessTasks: onSuccessChkPktLotNo

    })
    const { data: dupReportNo = [], mutate: funChkReportNo } = usePost({
        url: apiRoute.memoEntry.checkReportNo,
        queryKey: "checkReportNoData",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    let index = selectedGridRowId
                    const newRows = [...rows]
                    let msg = ""
                    show("Duplicate Report No. not allowed.")
                    rows[index][RowsField.reportNo] = ""
                    setRows(newRows)
                }
            }
        }

    })
    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.memoEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                if (data[0].count > 0) {
                    let index = selectedGridRowId
                    const newRows = [...rows]
                    let msg = ""
                    show("Duplicate Rough No. not allowed.")
                    rows[index][RowsField.lotNo] = ""
                    setRows(newRows)
                }
            }

        }

    })


    // const funMixgeAdWeight = (index) => {
    //     let totalOldWeight = 0;
    //     let totalNewWeight = 0;
    //     let matchCount = 0;

    //     const newRows = [...rows];

    //     const arr = Object.keys(mixStockParams).map((ele) => ({
    //         [ele]: newRows[index][ele] ?? ""
    //     }));

    //     const newObj = Object.assign({}, ...arr);

    //     const allKeysHaveValue = Object.values(newObj).every(
    //         value => value !== "" && value !== null && value !== undefined
    //     );

    //     if (!allKeysHaveValue) {
    //         return {
    //             totalWeight: 0,
    //             totalOldWeight: 0
    //         };
    //     }

    //     newRows.forEach((item, i) => {
    //         if (
    //             //  i !== index &&
    //             // item.detailId === 0 &&
    //             Object.entries(newObj).every(
    //                 ([key, value]) => item[key] === value
    //             )
    //         ) {


    //             totalNewWeight += Number(item.weight || 0);
    //             console.log(item?.weight, i)
    //         }
    //     });

    //     newRows.forEach((item, i) => {
    //         if (
    //             //  i !== index &&
    //             // item.detailId === 0 &&
    //             Object.entries(newObj).every(
    //                 ([key, value]) => item[key] === value
    //             )
    //         ) {
    //             totalOldWeight += Number(item.oldWeight || 0);
    //         }
    //     });

    //     const currentDetailId = Number(
    //         newRows[index][RowsField.detailId] || 0
    //     );

    //     newRows.forEach((item, i) => {

    //         const isMatch = Object.entries(newObj).every(
    //             ([key, value]) => item[key] === value
    //         );

    //         if (isMatch) {
    //             matchCount++;
    //         }
    //     });

    //     if (matchCount > 1) {

    //         return {
    //             totalOldWeight,
    //             totalNewWeight,
    //             matchCount,

    //         };
    //     }

    //     return {
    //         totalOldWeight: 0,
    //         totalNewWeight: 0,
    //         matchCount: 0
    //     };
    // };

    const funMixgeAdWeight = (index) => {
        const currentRow = rows[index];

        if (!currentRow) {
            return {
                totalOldWeight: 0,
                totalNewWeight: 0,
                matchCount: 0
            };
        }

        const matchKeys = Object.keys(mixStockParams);

        // Check current row has all required values
        const newObj = matchKeys.reduce((obj, key) => {
            obj[key] = currentRow[key] ?? "";
            return obj;
        }, {});

        const allKeysHaveValue = matchKeys.every(
            key => newObj[key] !== ""
        );

        if (!allKeysHaveValue) {
            return {
                totalOldWeight: 0,
                totalNewWeight: 0,
                matchCount: 0
            };
        }

        let totalOldWeight = 0;
        let totalNewWeight = 0;
        let matchCount = 0;

        rows.forEach((item, i) => {
            const isMatch = matchKeys.every(
                key => item[key] === newObj[key]
            );

            if (!isMatch) return;

            matchCount++;

            totalOldWeight += Number(item.oldWeight || 0);
            totalNewWeight += Number(item.weight || 0);

            console.log(item?.weight, i);
        });

        if (matchCount > 1) {
            return {
                totalOldWeight,
                totalNewWeight,
                matchCount
            };
        }

        return {
            totalOldWeight: 0,
            totalNewWeight: 0,
            matchCount: 0
        };
    };
    const { data: mixStockData = [], mutate: filterMixStock } = usePost({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchMixStockData",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {

                let index = selectedGridRowId
                if (data[0].weight > 0) {

                    const newRows = [...rows]


                    let t_weight = 0
                    const { totalOldWeight, matchCount, totalNewWeight } = funMixgeAdWeight(index)

                    if (matchCount > 1) {
                        const wt = (parseFloat(data[0].weight) + totalOldWeight) - (parseFloat(totalNewWeight) - parseFloat(data[0].weight))
                        console.log("new", parseFloat(data[0].weight), totalOldWeight, matchCount, totalNewWeight, wt)
                        if (wt <= 0) {
                            show("Same Mix Item Stock Not Found")
                            t_weight = 0
                        }
                        else
                            t_weight = wt.toFixed(2)
                    }
                    else
                        t_weight = data[0].weight

                    // newRows[index][RowsField.weight] = data[0].weight

                    newRows[index][RowsField.pcs] = data[0].pcs
                    newRows[index][RowsField.weight] = t_weight
                    if (newRows[index][RowsField.detailId] == 0) {
                        newRows[index][RowsField.oldPcs] = 0
                        newRows[index][RowsField.oldWeight] = 0
                    }
                    //  }
                    newRows[index][RowsField.bPcs] = data[0].pcs
                    newRows[index][RowsField.bWeight] = data[0].weight

                    setRows(newRows)
                    const newObject = Object.keys(mixStockParams).reduce((accumulator, key) => {
                        accumulator[key] = ''
                        return accumulator;
                    }, {});
                    setMixStockParams(newObject)


                }
                else {

                    const newRows = [...rows]

                    newRows[index][RowsField.pcs] = 0
                    newRows[index][RowsField.weight] = 0
                    setRows(newRows)
                    show("Mix Stock Not Found")

                }
            }
            else {
                show("Mix Stock Not Found")

            }
        }

    })
    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",

    })
    const { mutate: CheckMixStock } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.fetchMixStock,
        queryKey: "fetchcheckMixStockData",

    })
    const { data: stockcheck = [], mutate: checkStock } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getOutStockLotPkt,
        queryKey: "fetchOuttockData",


    })

    const focusInputCell = (rowId, field) => {
        setTimeout(() => {
            const Cell = gridContainerRef.current?.querySelector(
                `[data-id="${rowId}"] [data-field="${field}"]`
            );

            if (Cell) {
                const input = Cell.querySelector("input");

                if (input) {
                    input.focus();
                    input.select(); // ✅ select all text
                }
            }

        }, 500);
    }

    const funSetSNGStockData = (data, index, rowData, isuploadChk) => {

        if (data && data.length > 0) {
            const newRows = [...rowData]// [...rows]
            //let index = selectedGridRowId
            newRows[index][RowsField.itemCode] = data[0].ItemCode
            newRows[index][RowsField.shapeCode] = data[0].ShapeCode
            newRows[index][RowsField.sizeCode] = data[0].SizeCode
            newRows[index][RowsField.colorCode] = data[0].ColorCode
            newRows[index][RowsField.purityCode] = data[0].PurityCode
            newRows[index][RowsField.reportNo] = data[0].ReportNo
            newRows[index][RowsField.lab] = data[0].Lab
            newRows[index][RowsField.lwRatio] = data[0].LwRatio
            newRows[index][RowsField.pcs] = data[0].BPcs
            newRows[index][RowsField.weight] = data[0].BWeight
            newRows[index][RowsField.pktNo] = data[0].PktNo
            newRows[index][RowsField.lotNo] = data[0].LotNo
            newRows[index][RowsField.sLotNo] = data[0].SLotNo
            newRows[index][RowsField.sPktNo] = data[0].SPktNo
            // if (!isuploadChk) {
            newRows[index][RowsField.dRate] = data[0].BRated
            newRows[index][RowsField.rate] = data[0].BRate
            // }
            // else {

            //  if (newRows[index][RowsField.dRate] == 0)
            //     newRows[index][RowsField.dRate] = data[0].BRated
            // if (newRows[index][RowsField.rate] == 0)
            //   newRows[index][RowsField.rate] = data[0].BRate
            // }
            const calData = funCalAllAmount(newRows, index, 0, 0, "")
            newRows[index][RowsField.amount] = calData.amount
            newRows[index][RowsField.dAmount] = calData.dAmount
            // if (isuploadChk) {
            //     newRows[index][RowsField.netAmt] = calData.netAmt
            //     newRows[index][RowsField.netAmtD] = calData.netAmtD
            // }
            setRows(newRows)
            if (selBillType == 'S') {
                let field = isDollarInvoice == 1 && CurrencySetting != "RS" ? RowsField.dRate : RowsField.rate;
                focusInputCell(index + 1, field)
                setTimeout(() => {
                    const gridScroller =
                        gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');

                    if (!gridScroller) return;

                    const middle =
                        (gridScroller.scrollWidth - gridScroller.clientWidth) / 2;

                    gridScroller.scrollTo({
                        left: middle,
                        behavior: "smooth"
                    });
                }, 250);
            }

        }
        else {
            const newRows = [...rowData]
            //let index = selectedGridRowId
            newRows[index][RowsField.itemCode] = ""
            newRows[index][RowsField.shapeCode] = ""
            newRows[index][RowsField.sizeCode] = ""
            newRows[index][RowsField.colorCode] = ""
            newRows[index][RowsField.purityCode] = ""
            newRows[index][RowsField.reportNo] = ""
            newRows[index][RowsField.lab] = ""
            newRows[index][RowsField.lwRatio] = ""
            newRows[index][RowsField.pcs] = 0
            newRows[index][RowsField.weight] = 0
            newRows[index][RowsField.pktNo] = ""
            newRows[index][RowsField.lotNo] = ""
            // if (isExcelImport) {
            //     const updatedRows = newRows.filter((ele) => ele.lotNo != '' && ele.pktNo != '')
            //     const rearrangedRows = updatedRows.map((row, index) => {

            //         return {
            //             ...row,
            //             id: index + 1, // Reassign IDs to start from 1 again
            //         }
            //     })

            //     setRows(rearrangedRows)
            // }
            // else
            setRows(newRows)
            show("Stock Not Found")
            focusInputCell(index + 1, RowsField.lotNo)
        }
    }

    const { data: stockData = [], mutate: filterStockData } = usePostMutateWithSuccess({
        url: apiRoute.memoEntry.fetchStockData,
        queryKey: "fetchStockData",
    })

    const funGenVouNo = (bookid, isNewVouNo) => {

        if (isNewVouNo && bookid && bookid != "" && selBillType != "" && selTradeOf != "") {
            generateVouNo({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: selBillType,
                    book_id: bookid,
                    trade_of: selTradeOf,
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD")
                }
            })
        }
    }

    const funGenBillNo = (bookid, isNewBill) => {

        if (isNewBill && bookid && bookid != "" && selBillType != "" && selTradeOf != "") {
            generateBillNo({
                data: {
                    comp_code: compCode.join(","),
                    vou_type: selBillType,
                    book_id: bookid,
                    trade_of: selTradeOf,
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD")
                }
            })
        }
    }
    const { isPending: isLoadingGridData, data: gridMasterData = [] } = useFetchWithBody({
        url: apiRoute.memoEntry.gridMasterData,
        queryKey: "fetchInvoiceGridMasterData",
    })

    const onSuccessVouno = (data) => {

        if (data && data.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                [formField.vouNo]: data[0]?.new_vou_no ?? '',
                // if(selBillType=='P')
                //[formField.billNo]: selBillType == 'P' ? data[0]?.new_vou_no : ""
            }))
        }
    }
    //get generted vouno
    const { mutate: generateVouNo } = usePost({
        url: apiRoute.invoiceEntry.generateVoucherNo,
        queryKey: "generate-vounohghgh",
        onSuccessTasks: onSuccessVouno
    })
    //generate Bill NO
    const { mutate: generateBillNo } = usePost({
        url: apiRoute.invoiceEntry.generateBillNo,
        queryKey: "generate-billno",
        onSuccessTasks: (data) => {

            if (data && data.length > 0) {
                setFormData((prevData) => ({
                    ...prevData,
                    [formField.billNo]: data[0]?.new_bill_no ?? ''
                    // [formField.challanNo]:data[0]?.new_vou_no
                }))
            }
        }
    })

    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.invoiceEntry.add_update,
        queryKey: "funAddUpdateInvoice",
        onSuccessTasks: (data) => {
            dispatch(resetDetailParams());
            if (submitBtnId == 'btnSaveNew') {

                setFormData(emptyFormField)
                setRows([])
                window.location.reload();
            }
            else if (submitBtnId == 'btnSavePrint') {
                let obj = {

                    comp_code: compCode.join(","),
                    bill_type: selBillType,
                    trade_of: selTradeOf,
                    trans_id: data,
                    token: token,
                    db_user: GetLoginCredentialDb(user, yearId)
                }
                let objMod = {
                    mod_name: selModName,
                    token: token,
                    db_user: GetLoginCredentialDb(user, yearId)
                }

                dispatch(setInvoiceDetail(obj))
                dispatch(setModSettingData(objMod))
                dispatch(resetDetailParams());
                setFormData(emptyFormField)
                setRows([])
                setIsExportDetails(false)
                setOpenDrawer(true)

            }
            else
                navigate(funGetMasterLink());
            submitLockRef.current = false; // 🔓 always release
        }
    })

    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.invoiceEntry.fetchEntryDetail,
        queryKey: "fetchInvoiceDetail",
    });


    const { mutate: funchkBillNo } = usePostMutateWithSuccess({
        url: apiRoute.invoiceEntry.checkBillNo,
        queryKey: "funcheck  Duplicate Bill No",

    })

    const funGetDupBillNo = (book_id, bill_no, party_id) => {
        if (book_id != "" && bill_no != "") {
            funchkBillNo({
                data: {
                    compcode: compCode.join(","),
                    bill_no: bill_no,
                    book_id: book_id,
                    bill_type: selBillType,
                    party_id: selBillType == "P" ? party_id : "",
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD"),
                },
                onSuccess: (data) => {
                    if (data && data.length > 0) {
                        if (isNewEntry || (!isNewEntry && funNormalizeInput(formData[formField.billNo]) !== funNormalizeInput(formData[formField.oldBillNo]))) {
                            show(<div>
                                {`Bill No - "${formData[formField.billNo]}" already exist.`}
                                <div className=' m-1 p-2 text-green-700 bg-green-50'> Please enter a new one.</div>
                            </div>)
                            setFormData({ ...formData, [formField.billNo]: !isNewEntry ? formData[formField.oldBillNo] : "" })
                        }
                    }
                }
            })
        }
    }
    const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
        url: apiRoute.modSetting.getMultiModSetting,
        queryKey: "fetchModSettingInwardItem",
    })

    const isSinglePacket = () => {
        if (ptype != "") {
            if (ptype == URIEncrypt.SinglePacket)
                return true
            else
                return false
        }
        else
            return false
    }
    let gridData = []

    const getLwRatioByShape = (shape) => {
        if (gridMasterData && Object.keys(gridMasterData).length > 0)
            return gridMasterData?.lwMaster.filter((ele) => ele.S_Code == shape)
        else
            return []
    }
    const funLoadMasterData = (tradeof, billtype, pkttype) => {
        filterMatserData({
            data: {
                compcode: compCode.join(","),
                tradeof: tradeof,
                billtype: billtype,
                pkttype: pkttype

            }
        })
    }

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)


        const params = [URIEncrypt.Polish, URIEncrypt.Rough, URIEncrypt.Rejection]
        if (!params.includes(String(trdtype)) || ![URIEncrypt.Sale, URIEncrypt.Purchase].includes(String(btype))
            || ![URIEncrypt.SinglePacket, URIEncrypt.Mix].includes(ptype))
            navigate(linksUrl.dashboard.tradingDashboard)

        if (btype && btype != "" && trdtype && trdtype != "" && ptype && ptype != "" && startDate != "" && endDate != "") {
            let t_tradeof = ''
            let t_entryLabel = ''
            let t_billtype = ''
            let t_pktType = ''
            let t_btype = btype.toLowerCase()
            let t_trdtype = trdtype.toLowerCase()
            let modName = ''

            if (ptype == URIEncrypt.SinglePacket)
                t_pktType = 'SNG'
            else
                t_pktType = 'MIX'
            if (t_btype == URIEncrypt.Sale.toLowerCase()) {
                t_billtype = 'S'
            }
            else if (t_btype == URIEncrypt.Purchase.toLowerCase()) {
                t_billtype = 'P'
            }
            if (t_trdtype == URIEncrypt.Polish.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Polish
                t_entryLabel = "Polish Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SalePolishInvoiceSingle : ENUM_MOD_NAME.SalePolishInvoiceMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchasePolishInvoiceSingle : ENUM_MOD_NAME.PurchasePolishInvoiceMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rough.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rough
                t_entryLabel = "Rough Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRoughInvoiceSingle : ENUM_MOD_NAME.SaleRoughInvoiceMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRoughInvoiceSingle : ENUM_MOD_NAME.PurchaseRoughInvoiceMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }
            else if (t_trdtype == URIEncrypt.Rejection.toLowerCase()) {
                t_tradeof = ENUM_TRADEOF_CODE.Rejection
                t_entryLabel = "Rejection Diamond "
                if (t_billtype == 'S') { modName = isSinglePacket() ? ENUM_MOD_NAME.SaleRejectionInvoiceSingle : ENUM_MOD_NAME.SaleRejectionInvoiceMix }
                else if (t_billtype == 'P') { modName = isSinglePacket() ? ENUM_MOD_NAME.PurchaseRejectionInvoiceSingle : ENUM_MOD_NAME.PurchaseRejectionInvoiceMix }
                setnaviCode(t_billtype == 'S' ? linksUrl.saleEntry.roughDiamond : t_billtype == 'P' ? linksUrl.purchaseEntry.roughDiamond : "")
            }

            setSelTradeOf(t_tradeof)
            setSelBillType(t_billtype)
            setEntryLabel(t_entryLabel)
            setSelPktType(t_pktType)
            setSelModName(modName)
            funLoadMasterData(t_tradeof, t_billtype, t_pktType)

            filterModSetting({
                data: {
                    page_mod: modName,
                    master_mod: ENUM_MOD_NAME.GeneralSettings
                }
            })
            filterXlTemplate({
                data: {
                    tempname: t_pktType == 'SNG' && t_billtype == 'S' ? 'MemoImport' : 'PurchaseMemoImport'
                }
            })
            if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
                const { comp_code, transaction_id, bill_type, trade_of } = detailParams

                funGetDetail({
                    data: {
                        compcode: comp_code,
                        transactionid: transaction_id,
                        billtype: bill_type,
                        tradeof: trade_of
                    }
                })
            }

        }
    }, [btype, trdtype, startDate, endDate])


    useEffect(() => {
        if (modSetting && Object.keys(modSetting).length > 0) {
            const modData = modSetting.pageData
            const generalData = modSetting.masterData
            const currSetting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS;
            setCurrencySetting(currSetting)
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, generalData);
            setIsUseMfgNoAsMktno(mktSetting)


            if (currSetting != ENUM_CURRENCY_SETTING_VAL.RS && selPktType == 'SNG')
                setIsDollarInvoice("1")
            else
                setIsDollarInvoice("0")

            setModSettingParams({
                Visibility: {
                    [RowsField.itemCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.itemDetail]: getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                },
                Value: {
                    [RowsField.itemCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.itemDetail]: getModValue(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,

                },
                Mandatory: {
                    [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Items, modData) ?? false,
                    [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LotNo, modData) ?? false,
                    [RowsField.pktNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.PktNo, modData) ?? false,
                    [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Shape, modData) ?? false,
                    [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Color, modData) ?? false,
                    [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Purity, modData) ?? false,
                    [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Size, modData) ?? false,
                    [RowsField.reportNo]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ReportNo, modData) ?? false,
                    [RowsField.lab]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.Lab, modData) ?? false,
                    [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.LxWRatio, modData) ?? false,
                    [RowsField.itemDetail]: getModMandatory(ENUM_MOD_PARAMETER.MemoEntry.ItemDetail, modData) ?? false,
                    "allowNegativeStock": selBillType == 'S' ? getModVisiblity(ENUM_MOD_PARAMETER.MemoEntry.AllowNegativeStock, modData) ?? false : false,


                },
                MixStock:
                    selTradeOf == "R" ? {
                        [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByItem, generalData) ?? false,
                        [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData) ?? false,
                        [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockBySize, generalData) ?? false,
                    } : {
                        [RowsField.itemCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByItem, generalData) ?? false,
                        [RowsField.lotNo]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLCode, generalData) ?? false,
                        [RowsField.shapeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByShape, generalData) ?? false,
                        [RowsField.colorCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByColor, generalData) ?? false,
                        [RowsField.purityCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByPurity, generalData) ?? false,
                        [RowsField.lwRatio]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLwRatio, generalData) ?? false,
                        [RowsField.sizeCode]: getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockBySize, generalData) ?? false,
                    }


            })
        }

    }, [modSetting])


    useEffect(() => {
        if (modSettingParams && modSettingParams?.MixStock) {
            let array = Object.entries(modSettingParams?.MixStock).filter(([key, value]) => value == true).map(([key]) => { return { [key]: "" } })

            const result = array.reduce((acc, obj) => {
                return { ...acc, ...obj }
            }, {})
            if (mixStockParams == "")
                setMixStockParams(result)
        }
    }, [modSettingParams])

    function fun_calBrok_Amt(totalAmount, totalDiscAmt, brokPer) {
        let res = ((parseFloat(totalAmount) - parseFloat(totalDiscAmt)) * parseFloat(brokPer)) / 100
        return res.toFixed(2)
    }

    if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
        if (detail && detail?.itemDetail && detail?.itemDetail?.length > 0) {

            gridData = detail?.itemDetail.map((item, i) => {

                return {
                    id: ++i,
                    itemCode: item?.Item_Code ?? "",
                    itemDetail: item?.Item_Det ?? "",
                    pcs: item?.Nos ?? 0,
                    weight: item?.Weight ?? 0,
                    rate: item?.Rate ?? 0,
                    amount: item?.Amount ?? 0,
                    dRate: item?.S_Rate ?? 0,
                    dAmount: item?.AmountD ?? 0,
                    convRate: item?.C_Rate ?? 0,
                    detailId: item?.DetailId ?? 0,
                    lotNo: item?.L_Code ?? "",
                    pktNo: item?.PktNo ?? "",
                    sLotNo: item?.SL_Code ?? "",
                    sPktNo: item?.SPktNo ?? "",
                    lwRatio: item?.Lw_Code ?? "",
                    objLwRatio: getLwRatioByShape(item?.S_Code ?? ""),
                    shapeCode: item?.S_Code ?? "",
                    colorCode: item?.Sh_Code ?? "",
                    purityCode: item?.Q_Code ?? "",
                    sizeCode: item?.Sz_Code ?? "",
                    reportNo: item?.ReportNo ?? "",
                    lab: item?.Lab ?? "",
                    oldWeight: item?.Weight ?? 0,
                    oldPcs: item?.Nos ?? 0,
                    oldDRate: item?.S_Rate ?? 0,
                    bWeight: item?.BWeight ?? 0,
                    bPcs: item?.BPcs ?? 0,
                    discPer: item?.DiscPer ?? 0,
                    discAmt: item?.DiscAmt ?? 0,
                    discAmtD: item?.DiscAmtD ?? 0,
                    stPer: item?.StPer ?? 0,
                    stAmt: item?.StAmt ?? 0,
                    astPer: item?.AstPer ?? 0,
                    astAmt: item?.AstAmt ?? 0,
                    netAmt: item?.Amount
                        ? fun_calNet_Amt(item?.Amount, item?.DiscAmt, item?.StAmt, item?.AstAmt)
                        : 0,
                    netAmtD: item?.AmountD
                        ? fun_calNet_AmtD(item?.AmountD ?? 0, item?.DiscAmtD ?? 0)
                        : 0,
                }
            })


        }
    }

    const formField = {
        transId: "transId",
        vouNo: "vouNo",
        bookId: "bookId",
        partyId: "partyId",
        brokerId: "brokerId",
        deliveryId: "deliveryId",
        billNo: "billNo",
        tradeType: "tradeType",
        locationId: "locaionId",
        billDate: "billDate",
        chalNo: "chalNo",
        remark: "remark",
        dueDays: "dueDays",
        dueDate: "dueDate",
        pcs: "pcs",
        weight: "weight",
        brokPer: "brokPer",
        refTrnId: "refTrnId",
        oldBillNo: "oldBillNo"

    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        const today = dayjs();
        if (key == formField.billDate)
            acc[key] = today.isAfter(dayjs(endDate))
                ? null
                : today.format("YYYY-MM-DD")
        else if (key == formField.dueDate)
            acc[key] = dayjs(Date()).format("YYYY-MM-DD");
        else if (key == formField.netAmount || key == formField.dueDays || key == formField.pcs || key == formField.weight || key == formField.refTrnId)
            acc[key] = 0
        else acc[key] = ""
        return acc
    }, {})


    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {
            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    setMktLotNo("")
                    setFormData({ ...formData, [formField.billDate]: null })
                    show("Lot No Series Not Found")
                    

                }
                else {
                    setMktLotNo(data[0].Mkt_LCode)
                }
            }
            else
                setMktLotNo('0')
        }

    })
    const funMktLotNo = (date) => {
        if (selBillType == 'P' && selPktType == 'SNG' && isNewEntry && !isUseMfgNoAsMktno) {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [rows, setRows] = useState([])

    const net_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmt",
            }),
        [rows]
    )
    const net_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "netAmtD",
            }),
        [rows]
    )
    const disc_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmtD",
            }),
        [rows]
    )
    const disc_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmt",
            }),
        [rows]
    )


    const total_Weight = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "weight",
            }),
        [rows]
    )
    const total_Rate = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "rate",
            }),
        [rows]
    )
    const total_Pcs = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "pcs",
            }),
        [rows]
    )
    const total_Amount = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "amount",
            }),
        [rows]
    )
    const total_AmountD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dAmount",
            }),
        [rows]
    )
    const total_RateD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "dRate",
            }),
        [rows]
    )
    const total_disc = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmt",
            }),
        [rows]
    )
    const total_discD = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "discAmtD",
            }),
        [rows]
    )
    const total_GSTtax = useMemo(

        () =>
            calculateTotal({
                data: rows,
                columnName: "stAmt",
            }),
        [rows]
    )
    const total_SGSTtax = useMemo(
        () =>
            calculateTotal({
                data: rows,
                columnName: "astAmt",
            }),
        [rows]
    )
    function fun_calNet_Amt(amount, discAmt, stAmt, astAmt) {
        let res =
            (parseFloat(amount) - parseFloat(discAmt)) + (parseFloat(stAmt) + parseFloat(astAmt))
        return Math.round(res)
    }
    function fun_calNet_AmtD(amountD, discAmtD) {
        let res =
            (parseFloat(amountD) - parseFloat(discAmtD))
        return res.toFixed(2)
    }
    function fun_calTds_Amt(grossAmt, tdsPer) {
        let res = (parseFloat(grossAmt) * parseFloat(tdsPer)) / 100
        return res.toFixed(2)
    }
    const total_BrokAmt = useMemo(() => fun_calBrok_Amt(total_Amount, total_disc, brokPer), [rows, brokPer])
    const total_BrokAmtD = useMemo(() => fun_calBrok_Amt(total_AmountD, total_discD, brokPer), [rows, brokPer])
    const total_TDSAmt = useMemo(() => fun_calTds_Amt(total_Amount, tdsPer), [rows, tdsPer])

    const initialRow = {
        [RowsField.detailId]: 0,
        [RowsField.itemCode]: "",
        [RowsField.itemName]: "",
        [RowsField.shapeName]: "",
        [RowsField.shapeCode]: "",
        [RowsField.itemDetail]: "",
        [RowsField.pktNo]: "",
        [RowsField.lotNo]: "",
        [RowsField.sPktNo]: "",
        [RowsField.sLotNo]: "",
        [RowsField.purityName]: "",
        [RowsField.purityCode]: "",
        [RowsField.colorName]: "",
        [RowsField.colorCode]: "",
        [RowsField.sizeName]: "",
        [RowsField.sizeCode]: "",
        [RowsField.reportNo]: "",
        [RowsField.lab]: "",
        [RowsField.lwRatio]: "",
        [RowsField.rate]: 0,
        [RowsField.amount]: 0,
        [RowsField.pcs]: 0,
        [RowsField.weight]: 0,
        [RowsField.discPer]: 0,
        [RowsField.discAmt]: 0,
        [RowsField.stPer]: 0,
        [RowsField.stAmt]: 0,
        [RowsField.astPer]: 0,
        [RowsField.astAmt]: 0,
        [RowsField.netAmt]: 0,
        [RowsField.oldWeight]: 0,
        [RowsField.oldPcs]: 0,
        [RowsField.bPcs]: 0,
        [RowsField.bWeight]: 0,
        [RowsField.dRate]: 0,
        [RowsField.dAmount]: 0,
        [RowsField.convRate]: 0,
        [RowsField.discAmtD]: 0,
        [RowsField.netAmtD]: 0,
        [RowsField.objLwRatio]: []


    }

    const itemGridHeadClass = "bill-grid-style"
    const [formData, setFormData] = useState({
        ...emptyFormField
    })


    const inputBoxes = {
        Row1: [
            {
                id: formField.vouNo,
                name: formField.vouNo,
                placeholder: "Vou No",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.bookId,
                name: formField.bookId,
                placeholder: "Book Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.bookMaster ? masterData?.bookMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },

        ],

        Row2: [

            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Party Name",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.deliveryId,
                name: formField.deliveryId,
                placeholder: "Ship To",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

        ],
        Row3: [
            {
                id: formField.billNo,
                name: formField.billNo,
                placeholder: "Bill No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
            {
                id: formField.billDate,
                name: formField.billDate,
                placeholder: " Bill Date",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],
        Row4: [
            {
                id: formField.brokerId,
                name: formField.brokerId,
                placeholder: "Broker",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.brokerMaster ? masterData?.brokerMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: false,
            },
            {
                id: formField.locationId,
                name: formField.locationId,
                placeholder: "Location",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.locationMaster ? masterData?.locationMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },

        ],
        Row5: [
            {
                id: formField.tradeType,
                name: formField.tradeType,
                placeholder: "Trade Type",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: CUSTOM_ENUM_TRADE_TYPE,
                itemkey: "t_type",
                itemvalue: "t_type",
                isrequired: true,
            },


            {
                id: formField.remark,
                name: formField.remark,
                placeholder: "Remark.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: false,
            },
        ]

    }
    const funUpdateItemGst = (tradeType, withBill, itemCode) => {

        let newRows = [...rows]
        let autoGst = true
        rows.map((element, index) => {
            if (!withBill) {
                newRows[index].stPer = 0
                newRows[index].astPer = 0
                autoGst = false
            }
            funCalculateGst(newRows, itemCode != '' && itemCode != null ? itemCode : element.itemCode, index, tradeType, autoGst, false, withBill)
        })

    }

    const funCalculateGst = (newRows, itemCode, index, tradeType, isAutoGst, isReturnData, withBill) => {
        //if (masterData && Object.keys(masterData).length > 0) {

        if (itemCode != null && itemCode.length > 0 && itemCode != "") {
            const tempData = masterData.itemMaster.filter((ele) => ele.Item_Code.toLowerCase() == itemCode.toLowerCase())
            //console.log(itemCode,isAutoGst,withBill,tempData,masterData.itemMaster)
            if (tempData) {

                if (tempData.length > 0) {
                    let t_StPer = parseFloat(tempData[0]?.STPer);
                    let t_AstPer = parseFloat(tempData[0]?.ASTPer)
                    //const calData=funCalAllAmount(newRows)
                    if (isAutoGst && withBill) {
                        if (["OGS","EXP","IMP"].includes(tradeType)) {
                            newRows[index].stPer = t_StPer + t_AstPer
                            newRows[index].astPer = 0;
                            t_StPer = t_StPer + t_AstPer
                            t_AstPer = 0;
                        }
                        else {
                            newRows[index].astPer = t_AstPer;
                            newRows[index].stPer = t_StPer;
                        }
                    }
                    else {
                        t_StPer = newRows[index].stPer ?? 0
                        t_AstPer = newRows[index].astPer ?? 0
                    }
                    let tempTot = 0;


                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt ?? 0) *
                            t_StPer) /
                        100
                    newRows[index].stAmt = tempTot.toFixed(2)

                    tempTot =
                        ((newRows[index].amount - newRows[index].discAmt ?? 0) *
                            t_AstPer) /
                        100
                    newRows[index].astAmt = tempTot.toFixed(2)

                    tempTot = fun_calNet_Amt(
                        newRows[index].amount,
                        newRows[index].discAmt,
                        newRows[index].stAmt,
                        newRows[index].astAmt
                    )
                    newRows[index].netAmt = tempTot
                    newRows[index].itemCode = itemCode
                }
            }


            //}
        }
        if (isReturnData) {
            console.log("hi")
            return newRows
        }
        else
            setRows(newRows)

        return newRows
    }
    const funSetTradeType = (partyId) => {
        if (partyId != "" && partyId != null) {
            let t_tradeType = formData.tradeType
            if (compState && compState?.trim() != "") {
                const tempData = masterData.acMaster.filter((ele) => ele.Party_Id == partyId)

                if (tempData?.length > 0) {
                    const data = tempData[0];

                    const itNo = data?.IT_NO?.toString()?.trim() ?? "";
                    const country = data?.Country?.toString()?.trim().toLowerCase() ?? "";
                    const add6 = data?.ADD_6?.toString()?.trim() ?? "";
                    const companyState = compState?.trim() ?? "";

                    const isExportImport =
                        itNo === "" &&
                        country !== "" &&
                        country !== "india";

                    if (isExportImport) {
                        t_tradeType = selBillType === "S" ? "EXP" : "IMP";
                    } else if (add6 !== "") {
                        t_tradeType =
                            add6.toLowerCase() === companyState.toLowerCase()
                                ? "RD"
                                : "OGS";
                    } else {
                        t_tradeType = "URD";
                    }
                }
                if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
                else setIsStPerDisable(true)
            }
            return t_tradeType
        }
        else
            return ""
    }
    const funValidateStock = (id, index, chkPcsValue, chkWeightValue, value) => {
        let newRows = [...rows]
        let t_oldPcs = newRows[index][RowsField.oldPcs];
        let stk_pcs = Number(chkPcsValue) + Number(t_oldPcs)
        let t_oldWeight = newRows[index][RowsField.oldWeight];
        let stk_weight = parseFloat(parseFloat(chkWeightValue)) + parseFloat(t_oldWeight)
        let mix_DupItemWt = chkWeightValue

        if (selPktType != "SNG") {
            newRows[index][RowsField.bPcs] = chkPcsValue
            newRows[index][RowsField.bWeight] = chkWeightValue

            const { matchCount, totalOldWeight, totalNewWeight } = funMixgeAdWeight(index)
            console.log(matchCount, totalOldWeight, totalNewWeight)
            let total_MixWeight = 0
            if (matchCount > 1) {
                if (isNewEntry)
                    total_MixWeight = (parseFloat(chkWeightValue)) || 0
                else
                    total_MixWeight = (parseFloat(chkWeightValue) + totalOldWeight) || 0

                //console.log(total_MixWeight, "avxc")
                //if (totalNewWeight > total_MixWeight) {
                stk_weight = (parseFloat(total_MixWeight) - (totalNewWeight - Number(newRows[index][RowsField.weight]))).toFixed(2)
                mix_DupItemWt = parseFloat(stk_weight)
                console.log(total_MixWeight, "h,", stk_weight)
                //  }
                // else
                //  stk_weight = (parseFloat(total_MixWeight) - (totalNewWeight - newRows[index][RowsField.weight])).toFixed(2)
            }
        }

        if (id == RowsField.pcs) {
            if (Number(value) > stk_pcs) {
                // toast.error(`Pcs should be less than (${stk_pcs})`, {
                //     "position": "top-center",
                //     "className": "toast-error",
                // })
                // if (newRows[index][RowsField.detailId] == 0)
                //     newRows[index][RowsField.pcs] = chkPcsValue
                // else
                //     newRows[index][RowsField.pcs] = t_oldPcs
            }

        }
        else if (id == RowsField.weight) {
            if (parseFloat(value) > stk_weight) {
                show(`Weight should be less than (${stk_weight})`)
                if (newRows[index][RowsField.detailId] == 0)
                    newRows[index][RowsField.weight] = selPktType != "SNG" ? mix_DupItemWt : chkWeightValue
                else
                    newRows[index][RowsField.weight] = t_oldWeight
            }

        }
        setRows(newRows)
    }

    const hanldeBlur = (index, e) => {


        const { value, name, id } = e.target

        setFocusedRowId(id)

        if (name == formField.billNo) {
            // if (selBillType == 'S')
            funGetDupBillNo(formData[formField.bookId], value, formData[formField.partyId])
        }
        else if (id == RowsField.reportNo || id == RowsField.lotNo || id == RowsField.pktNo) {
            setSelectedGridRowId(index)
            const newRows = [...rows]
            let t_lotno = id == RowsField.lotNo ? value : newRows[index][RowsField.lotNo]
            let t_pktno = id == RowsField.pktNo ? value : newRows[index][RowsField.pktNo]
            let t_reportno = id == RowsField.reportNo ? value : newRows[index][RowsField.reportNo]
            let isDuplicate = 0;
            if (selPktType == 'SNG' && id == RowsField.reportNo && value != "") {

                const pktData = rows.filter((ele, i) => i != index && ele.reportNo.toLowerCase() == value.toLowerCase())

                if (pktData && pktData.length > 0) {
                    isDuplicate = 1
                    show("Duplicate ReportNo. not allow")
                    // toast.error("Duplicate ReportNo. not allow", {
                    //     position: "top-center",
                    //     "className": "toast-error",
                    // })
                    newRows[index][RowsField.reportNo] = ""
                    setRows(newRows)
                }
            }
            else if (selPktType == 'SNG' && t_lotno != "" && t_pktno != "") {
                const pktData = rows.filter((ele, i) => i != index && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                if (pktData && pktData.length > 0) {
                    // if (pktData[0].id != index + 1) {
                    isDuplicate = 1
                    show(<div> Duplicate Lot No. and Pkt No. not allowed
                        <div className='text-yellow-600 bg-yellow-50 p-2 m-1  text-xs '>The combination of Lot No. and Pkt No. must be unique.</div>
                    </div>)
                    // toast.error("duplicate lot No and Pkt No. not allow", {
                    //     position: "top-center"
                    // })
                    newRows[index][RowsField.lotNo] = ""
                    newRows[index][RowsField.pktNo] = ""
                    setRows(newRows)
                    //  }
                }
            }
            if (!isDuplicate) {
                if (selBillType == 'P') {
                    if (selPktType == 'SNG') {
                        if (id == RowsField.reportNo) {
                            const pktData = rows.filter((ele, i) => i != index && ele.reportNo.toLowerCase() == value.toLowerCase())
                            if (pktData && pktData.length > 0) {
                                funChkReportNo({
                                    data: {
                                        reportno: value
                                    }
                                })
                            }
                        }
                        else if (id == RowsField.pktNo || id == RowsField.lotNo) {

                            const pktData = rows.filter((ele, i) => i != index && ele.lotNo.toLowerCase() == t_lotno.toLowerCase() && ele.pktNo.toLowerCase() == t_pktno.toLowerCase())
                            funChkPktLotNo({
                                data: {
                                    compcode: compCode.join(","),
                                    lotno: t_lotno,
                                    pktno: t_pktno,
                                    mktlcode: mktLotNo || '0'
                                },
                                onSuccess: (data) => {

                                    onSuccessChkPktLotNo(data, index, rows);
                                }
                            })
                        }
                    }
                    else if (selTradeOf == 'R') {

                        funChkRoughNo({
                            data: {

                                compcode: compCode.join(","),
                                roughno: t_lotno,
                            }
                        })
                    }
                }
                else if (selBillType == 'S') {
                    if (selPktType == 'SNG') {
                        if (id == RowsField.reportNo && t_reportno != "" && !isDisableSubmit) {
                            filterStockData({

                                data: {
                                    compcode: compCode.join(","),
                                    reportno: t_reportno,
                                    tradeof: selTradeOf,
                                    action: 'Stock_By_ReportNo'
                                },
                                onSuccess: (data) => {
                                    funSetSNGStockData(data, index, rows, false)
                                }
                            })
                        }
                        else if (t_lotno != "" && t_pktno != "" && !isDisableSubmit) {

                            filterStockData({
                                data: {
                                    compcode: compCode.join(","),
                                    lotno: t_lotno,
                                    pktno: t_pktno,
                                    tradeof: selTradeOf
                                },
                                onSuccess: (data) => {
                                    funSetSNGStockData(data, index, rows, false)
                                }
                            })
                        }
                    }

                }
                if (mixStockParams.hasOwnProperty(id) && selPktType != "SNG")
                    funSetMixStockKeys(RowsField.lotNo, value)
            }

        }
        else if (id == RowsField.pcs || id == RowsField.weight) {
            const newRows = [...rows]

            let chkPcsValue = ""
            let chkWeightValue = ""
            if (selPktType == 'SNG' && selBillType == 'P' && Number(newRows[index][RowsField.detailId] > 0)) {
                chkPcsValue = newRows[index][RowsField.bPcs]
                chkWeightValue = newRows[index][RowsField.bWeight]

            }
            else if (selPktType == "MIX" && selBillType == 'S' && modSettingParams && !modSettingParams.Mandatory.allowNegativeStock) {
                let newObj = ""
                //check mix stock
                Object.keys(mixStockParams).map((mapkey) => {
                    newObj = { ...newObj, [mapkey]: newRows[index][mapkey] }
                })
                const allKeysHaveValue = Object.values(newObj).every(value => value !== "" && value !== null && value !== undefined);
                if (allKeysHaveValue && newRows[index][RowsField.bWeight] <= 0) {
                    CheckMixStock({
                        data: {
                            compcode: compCode.join(","),
                            itemcode: mixStockParams.hasOwnProperty(RowsField.itemCode) ? newObj[RowsField.itemCode] : null,
                            lotno: mixStockParams.hasOwnProperty(RowsField.lotNo) ? newObj[RowsField.lotNo] : null,
                            pktno: mixStockParams.hasOwnProperty(RowsField.pktNo) ? newObj[RowsField.pktNo] : null,
                            scode: mixStockParams.hasOwnProperty(RowsField.shapeCode) ? newObj[RowsField.shapeCode] : null,
                            shcode: mixStockParams.hasOwnProperty(RowsField.colorCode) ? newObj[RowsField.colorCode] : null,
                            qcode: mixStockParams.hasOwnProperty(RowsField.purityCode) ? newObj[RowsField.purityCode] : null,
                            szcode: mixStockParams.hasOwnProperty(RowsField.sizeCode) ? newObj[RowsField.sizeCode] : null,
                            lwcode: mixStockParams.hasOwnProperty(RowsField.lwRatio) ? newObj[RowsField.lwRatio] : null,
                            tradeof: selTradeOf
                        },
                        onSuccess: (data) => {
                            if (data && data.length > 0) {
                                chkPcsValue = data[0].pcs
                                chkWeightValue = data[0].weight




                                funValidateStock(id, index, chkPcsValue, chkWeightValue, value)
                                const newObject = Object.keys(mixStockParams).reduce((accumulator, key) => {
                                    accumulator[key] = ''
                                    return accumulator;
                                }, {});

                                setMixStockParams(newObject)
                            }
                        }

                    })
                }
                else {
                    chkPcsValue = newRows[index][RowsField.bPcs] //oldPcs
                    chkWeightValue = newRows[index][RowsField.bWeight]
                }

            }
            if (chkPcsValue != "" || chkWeightValue != "") {
                console.log("hi")
                funValidateStock(id, index, chkPcsValue, chkWeightValue, value)

            }

        }
        // else if (id == RowsField.lwRatio) {
        //     if (selPktType == "MIX" && selBillType == 'S') {
        //         if (mixStockParams.hasOwnProperty(id))
        //             funSetMixStockKeys(RowsField.lwRatio, value)
        //     }
        // }

    }

    const funSetMixStockKeys = (key, value) => {
        if (selPktType == 'MIX') {
            if (modSettingParams && modSettingParams?.MixStock) {
                if (mixStockParams.hasOwnProperty(key)) {
                    let newRows = [...rows]
                    let index = selectedGridRowId ?? 0
                    const arr = Object.keys(mixStockParams).map((ele) => {
                        if (ele == key)
                            return { [ele]: value }
                        else
                            return { [ele]: newRows[index][ele] ?? "" }
                    })

                    const merged = Object.assign({}, ...arr);

                    //const newObj = { ...mixStockParams, [key]: value }
                    const newObj = { ...merged }
                    const allKeysHaveValue = Object.values(newObj).every(value => value !== "" && value !== null && value !== undefined);
                    if (allKeysHaveValue) {
                        let duplicate = 0
                        // const duplicateRows = rows.filter((item, i) => i !== index &&
                        //     Object.entries(newObj).every(
                        //         ([key, value]) => item[key] === value
                        //     )
                        // );

                        // if (duplicateRows && duplicateRows?.length > 0) {
                        //     duplicate = 1

                        //     // show("Duplicate items not allow it already added")

                        //     const newRows = [...rows]
                        //     let index = selectedGridRowId ?? 0
                        //       Object.keys(newObj).map((ele) => {
                        //     newRows[index]["isDuplicate"] = 1
                        //     })
                        //     setRows(newRows)
                        // }
                        if (selBillType == 'S' && !duplicate) {
                            filterMixStock({
                                data: {
                                    compcode: compCode.join(","),
                                    itemcode: mixStockParams.hasOwnProperty(RowsField.itemCode) ? newObj[RowsField.itemCode] : null,
                                    lotno: mixStockParams.hasOwnProperty(RowsField.lotNo) ? newObj[RowsField.lotNo] : null,
                                    pktno: mixStockParams.hasOwnProperty(RowsField.pktNo) ? newObj[RowsField.pktNo] : null,
                                    scode: mixStockParams.hasOwnProperty(RowsField.shapeCode) ? newObj[RowsField.shapeCode] : null,
                                    shcode: mixStockParams.hasOwnProperty(RowsField.colorCode) ? newObj[RowsField.colorCode] : null,
                                    qcode: mixStockParams.hasOwnProperty(RowsField.purityCode) ? newObj[RowsField.purityCode] : null,
                                    szcode: mixStockParams.hasOwnProperty(RowsField.sizeCode) ? newObj[RowsField.sizeCode] : null,
                                    lwcode: mixStockParams.hasOwnProperty(RowsField.lwRatio) ? newObj[RowsField.lwRatio] : null,
                                    tradeof: selTradeOf
                                }
                            })
                        }
                    }
                    setMixStockParams(newObj)
                }
            }

        }
    }
    const handleChange = (e) => {
        const { name, value } = e.target
        let t_dueDate = formData[formField.dueDate]
        if (name == formField.dueDays) {
            if (formData[formField.billDate] && formData[formField.billDate] != ""
                && formData[formField.billDate] != "Invalid Date" && value != "") {
                t_dueDate = addDays(formData[formField.billDate], Number(value))
            }
        }
        setFormData({ ...formData, [name]: value, [formField.dueDate]: t_dueDate })
    }
    const handleCheckChange = (val) => {
        setIsWithBill(val)

        funUpdateItemGst(formData.tradeType, val, '')

    }

    const handleAutoCompleteChange = (value, rowid, name) => {

        if (name == formField.partyId || name == formField.deliveryId || name == formField.tradeType || name == formField.bookId || name == formField.brokerId || name == formField.locationId) {
            let t_tradeType = formData.tradeType
            let t_deliveryId = formData.deliveryId
            let t_brokerId = formData?.brokerId ?? "";

            if (name == formField.deliveryId)
                t_deliveryId = value
            if (name == formField.bookId) {
                // funGetDupBillNo(value, formData[formField.billNo])
                funGenVouNo(value, isNewEntry)
                funGenBillNo(value, isNewEntry)

            }
            else if (name == formField.partyId) {
                if (selBillType == 'P')
                    funGetDupBillNo(formData[formField.bookId], formData[formField.billNo], value)
                t_tradeType = funSetTradeType(value)
                if (rows && rows.length > 0) {
                    funUpdateItemGst(t_tradeType, isWithBill, '')
                }
                if (t_deliveryId == "" || t_deliveryId == null)
                    t_deliveryId = value
                const { MapId, BrokerPer } = getPartymapingData('Broker', value)
                t_brokerId = MapId
                setBrokPer(BrokerPer)
                //t_brokerPer=
            }
            else if (name == formField.tradeType) {
                // if (t_tradeType == "")
                t_tradeType = value
                if (t_tradeType == "URD" || t_tradeType == "RD") setIsStPerDisable(false)
                else setIsStPerDisable(true)
                funUpdateItemGst(value, isWithBill, '')
            }
            else if (name == formField.brokerId) {
                t_brokerId = value
            }
            setFormData({
                ...formData,
                [name]: value,
                [formField.tradeType]: t_tradeType,
                [formField.deliveryId]: t_deliveryId,
                [formField.brokerId]: t_brokerId

            })
        }

        else {

            // if (name == RowsField.itemName && rows.find((ele) => ele.itemCode == value)) {
            //     addToast({
            //         title: "",
            //         description: "Item already added",
            //         color: "danger"
            //     })
            //     const index = rows.findIndex((ele) => ele.id == rowid)
            //     let newRow = [...rows]
            //     funCalculateGst(newRow, value, index, formData.tradeType, true, false, isWithBill)
            //     newRow[index].itemCode = ""
            //     newRow[index].itemName = ""
            //     setRows(newRow)
            // }
            // else {

            let name_val = ""
            let tempData = []
            let findData = []
            let keyfield = ""
            const index = rows.findIndex((ele) => ele.id == rowid)
            setSelectedGridRowId(index)

            if (name == RowsField.itemName) {
                keyfield = RowsField.itemCode
                tempData = masterData.itemMaster
                findData = tempData.filter((ele) => ele.Item_Code == value)
                name_val = findData[0]?.Item_Desc ?? ''
                funSetMixStockKeys(keyfield, value)

            }
            else if (name == RowsField.shapeName) {
                keyfield = RowsField.shapeCode
                tempData = gridMasterData.shapeMaster
                findData = tempData.filter((ele) => ele.S_Code == value)
                name_val = findData[0]?.S_Name ?? ''
                funSetMixStockKeys(keyfield, value)
            }
            else if (name == RowsField.colorName) {
                keyfield = RowsField.colorCode
                tempData = gridMasterData.colorMaster
                findData = tempData.filter((ele) => ele.Sh_Code == value)
                name_val = findData[0]?.Sh_Name ?? ''
                funSetMixStockKeys(keyfield, value)
            }
            else if (name == RowsField.purityName) {
                keyfield = RowsField.purityCode
                tempData = gridMasterData.purityMaster
                findData = tempData.filter((ele) => ele.Q_Code == value)
                name_val = findData[0]?.Q_Name ?? ''
                funSetMixStockKeys(keyfield, value)
            }
            else if (name == RowsField.sizeName) {
                keyfield = RowsField.sizeCode
                tempData = gridMasterData.sizeMaster
                findData = tempData.filter((ele) => ele.Sz_Code == value)
                name_val = findData[0]?.Sz_Name ?? '' // +" " +findData[0].T_Size
                funSetMixStockKeys(keyfield, value)
            }
            else if (name == RowsField.lwRatio) {

                keyfield = RowsField.lwRatio
                tempData = gridMasterData.lwMaster
                name_val = value
                findData = tempData.filter((ele) => ele.LwCode == value)
                funSetMixStockKeys(keyfield, value)
            }

            let newRow = [...rows]

            if (findData && findData.length > 0) {
                if (name == RowsField.shapeName) {
                    newRow[index][RowsField.objLwRatio] = getLwRatioByShape(value)
                }
                newRow[index][keyfield] = value
                newRow[index][name] = name_val
                if (isExcelImport && selBillType == 'P' && name == RowsField.itemName) {
                    const upData = newRow.map((ele) => ({
                        ...ele, [RowsField.itemCode]: value, [RowsField.itemName]: name_val
                    }))
                    setRows(upData)
                }
                else
                    setRows(newRow)

            }

            //}
        }



    }
    const handleDeleteRow = (id) => {

        const updatedRows = rows.filter((row) => row.id !== id)
        let DeletedRow = rows.filter((row) => row.id == id)
        const rearrangedRows = updatedRows.map((row, index) => {
            // if (row.id == 10000)
            //     return row
            // else
            return {
                ...row,
                id: index + 1, // Reassign IDs to start from 1 again
            }
        })

        setRows(rearrangedRows)
        setDeletedItemRows([...deletedItemRows, ...DeletedRow])
    }

    const funCalAllAmount = (rowData, index, pcs, weight, currentID) => {
        const newRows = rowData?.length ? [...rowData] : [...rows];
        const row = newRows[index];

        // Basic values
        let t_rate = parseFloat(row.rate) || 0;
        let t_DRate = parseFloat(row.dRate) || 0;
        const t_pcs = pcs > 0 ? parseFloat(pcs) : parseFloat(row.pcs) || 0;
        const t_wt = weight > 0 ? parseFloat(weight) : parseFloat(row.weight) || 0;
        const convRt = parseFloat(row.convRate) || 0;

        /* ================= Currency Conversion ================= */
        if (CurrencySetting !== ENUM_CURRENCY_SETTING_VAL.RS && convRt > 0) {
            if (currentID === RowsField.rate) {
                t_DRate = parseFloat((t_rate / convRt).toFixed(2));
            }
            else if (currentID === RowsField.dRate) {
                t_rate = parseFloat((t_DRate * convRt).toFixed(2));
            }
            else if (currentID === RowsField.convRate) {
                if (t_DRate > 0) t_rate = parseFloat((t_DRate * convRt).toFixed(2));
                else if (t_rate > 0) t_DRate = parseFloat((t_rate / convRt).toFixed(2));
            }
        }

        /* ================= Amount Calculation ================= */
        const t_Amount = parseFloat((t_rate * t_wt).toFixed(2));
        const t_DAmount = parseFloat((t_DRate * t_wt).toFixed(2));

        /* ================= Discount / Tax ================= */
        const discPer = parseFloat(row.discPer) || 0;
        const discAmt = parseFloat(((t_Amount * discPer) / 100).toFixed(2));
        const discAmtD = parseFloat(((t_DAmount * discPer) / 100).toFixed(2));

        const baseAmt = t_Amount - (parseFloat(row.discAmt) || 0);
        const stAmt = parseFloat(((baseAmt * (parseFloat(row.stPer) || 0)) / 100).toFixed(2));
        const astAmt = parseFloat(((baseAmt * (parseFloat(row.astPer) || 0)) / 100).toFixed(2));

        /* ================= Net Amount ================= */
        const netAmt = fun_calNet_Amt(t_Amount, discAmt, stAmt, astAmt);
        const netAmtD = fun_calNet_AmtD(t_DAmount, discAmtD);

        return {
            rate: t_rate,
            dRate: t_DRate,
            amount: t_Amount,
            dAmount: t_DAmount,
            discAmt,
            discAmtD,
            stAmt,
            astAmt,
            netAmt,
            netAmtD
        };
    };

    const funGetUpdateRows = (upField, value) => {
        let _selVal = value
        const newRows = [...rows]
        const nData = rows.map((ele, index) => {
            if (upField == RowsField.dRate)
                newRows[index][upField] = _selVal != "" && Number(value) >= 0 && _selVal != null ? _selVal : newRows[index].oldDRate
            else {
                _selVal = Number(value) > 0 ? value : ""
                newRows[index][upField] = value != "" && Number(value) > 0 && value != null ? _selVal : ""
            }
            const calData = funCalAllAmount(newRows, index, 0, 0, upField)
            const upRow = {
                ...ele, [upField]: _selVal, [RowsField.amount]: calData.amount,
                [RowsField.dAmount]: calData.dAmount, [RowsField.rate]: calData.rate,
                [RowsField.dRate]: calData.dRate, [RowsField.discAmt]: calData.discAmt,
                [RowsField.discAmtD]: calData.discAmtD, [RowsField.netAmt]: calData.netAmt,
                [RowsField.netAmtD]: calData.netAmtD
            }
            const newUpRow = funCalculateGst([upRow], ele.itemCode, 0, formData.tradeType, false, true, isWithBill)

            return newUpRow[0]

        })
        return nData || []
    }
    const handleDRateChange = (e) => {
        const { value } = e.target

        setSelDRate(value)
        const UpRows = funGetUpdateRows(RowsField.dRate, value)
        setRows(UpRows)

    }
    const handleDiscPerChange = (e) => {
        const { value } = e.target

        setSelDiscPer(value)
        const UpRows = funGetUpdateRows(RowsField.discPer, value)
        setRows(UpRows)
        // }
        // else
        //     setSelDiscPer("")
        // const newRows = [...rows]
        // const nData = rows.map((ele, index) => {
        //     newRows[index][RowsField.discPer] = value
        //     const calData = funCalAllAmount(newRows, index, 0, 0, RowsField.discPer)
        //     const upRow = {
        //         ...ele, [RowsField.discPer]: value, [RowsField.amount]: calData.amount,
        //         [RowsField.dAmount]: calData.dAmount, [RowsField.rate]: calData.rate,
        //         [RowsField.dRate]: calData.dRate, [RowsField.discAmt]: calData.discAmt,
        //         [RowsField.discAmtD]: calData.discAmtD, [RowsField.netAmt]: calData.netAmt,
        //         [RowsField.netAmtD]: calData.netAmtD
        //     }
        //     const newUpRow = funCalculateGst([upRow], ele.itemCode, 0, formData.tradeType, false, true, isWithBill)

        //     return newUpRow[0]

        // })
        // console.log(nData, "fg")

    }
    const handleConvRateBlur = () => {
        // const newRows = [...rows]
        const value = selConvRate
        const UpRows = funGetUpdateRows(RowsField.convRate, value)
        setRows(UpRows)
        // const nData = rows.map((ele, index) => {
        //     newRows[index][RowsField.convRate] = value
        //     const calData = funCalAllAmount(newRows, index, 0, 0, RowsField.convRate)
        //     const upRow = {
        //         ...ele, [RowsField.convRate]: value, [RowsField.amount]: calData.amount,
        //         [RowsField.dAmount]: calData.dAmount, [RowsField.rate]: calData.rate,
        //         [RowsField.dRate]: calData.dRate, [RowsField.netAmt]: calData.netAmt,
        //         [RowsField.netAmtD]: calData.netAmtD
        //     }

        //     const newUpRow = funCalculateGst([upRow], ele.itemCode, 0, formData.tradeType, false, true, isWithBill)

        //     return newUpRow[0]
        // })

        // console.log(nData, "fg")
        //setRows(nData)
    }
    const handleConvRateChange = (e) => {
        const { value } = e.target
        if (funValidateNoInput(value))
            setSelConvRate(value)


    }
    const handleChkSameItem = (value) => {
        setIsSameItem(value)
        let item = ""
        if (value == true) {
            item = rows[0]?.itemCode || ""
            if (item == "") {
                show("Select an item in the first row to apply it to all rows")
                setIsSameItem(false)
                return;
            }
            funUpdateItemGst(formData.tradeType, isWithBill, item)
        }
        else {
            const newData = rows.map((ele) => {
                return { ...ele, [RowsField.itemCode]: '', [RowsField.astPer]: 0, [RowsField.astAmt]: 0, [RowsField.stPer]: 0, [RowsField.stAmt]: 0 }
            })
            setIsWithBill(false)
            setRows(newData)
        }

    }
    //end delete row from dynamic grid
    const handleInputChange = (rowId, e, name) => {

        let { value, id } = e.target
        let index = rows.findIndex(ele => ele.id == rowId)
        const newRows = [...rows]

        setSelectedGridRowId(index)

        newRows[index][id] = value


        if (id == RowsField.rate ||
            id == RowsField.pcs ||
            id == RowsField.weight ||
            id == RowsField.discPer ||
            id == RowsField.stPer ||
            id == RowsField.astPer ||
            id == RowsField.convRate ||
            id == RowsField.dRate
        ) {


            let isAutoGst = true
            if (id == RowsField.stPer || id == RowsField.astPer) {
                isAutoGst = false
            }
            const calData = funCalAllAmount(newRows, index, 0, 0, id)

            newRows[index].amount = calData.amount
            newRows[index].dAmount = calData.dAmount
            newRows[index].discAmtD = calData.discAmtD
            newRows[index].discAmt = calData.discAmt
            newRows[index].stAmt = calData.stAmt
            newRows[index].astAmt = calData.astAmt
            newRows[index].netAmt = calData.netAmt
            newRows[index].netAmtD = calData.netAmtD
            if (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS) {
                if (id != RowsField.dRate)
                    newRows[index].dRate = calData.dRate //.toFixed(2)
                if (id != RowsField.rate)
                    newRows[index].rate = calData.rate //.toFixed(2)
            }
            funCalculateGst(newRows, newRows[index][RowsField.itemCode], index, formData.tradeType, isAutoGst, false, isWithBill)

        }

        setRows(newRows)
    }
    const funIsFooter = (id) => {
        if (id == 100000)
            return true
        else
            return false
    }
    const renderInputCell = (row, input_id, input_type, is_readonly, holder_text, is_required, variant, color) => {

        return (

            <InputCell
                row={row}
                input_id={input_id}
                input_type={input_type}
                is_readonly={is_readonly}
                holder_text={holder_text}
                is_required={is_required}
                //is_disabled={}
                variant={variant ? variant : "bordered"}
                color={color ? color : ""}
                handleInputChange={handleInputChange}
                hanldeBlur={hanldeBlur}
                isStPerDisable={isStPerDisable}
            />


        )
    }
    const setColumnRequired = (column) => {
        if (selPktType == "MIX") {
            if (mixStockParams && mixStockParams.hasOwnProperty(column))
                return true
            else if (modSettingParams && modSettingParams?.Mandatory) {
                return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false

            }
        }
        else if (modSettingParams && modSettingParams?.Mandatory) {
            return Object.keys(modSettingParams?.Mandatory).length > 0 ? modSettingParams?.Mandatory[column] : false
        }
        else
            return false
    }

    const setColumnDisable = (row) => {
        console.log(isRefId,row)
        if (!isRefId) {
            if (selBillType == 'S') {
                if (selPktType == 'SNG') {
                    return true
                }
            }
            else if (selBillType == 'P') {
                console.log(row,"fg")
                if (selPktType == 'SNG' && row.detailId > 0 && row.bPcs <= 0 && row.bWeight <= 0)
                    return true
                else
                    return false
            }
        }
        else return true
    }

    const setColumnVisiblity = (column) => {
        if (modSetting && Object.keys(modSetting).length > 0)
            return modSettingParams && Object.keys(modSettingParams).length > 0 ? modSettingParams?.Visibility[column] : true
        else
            return true
    }

    const setNegativeStockEnable = () => {
        if (selPktType == "MIX" && modSettingParams) {
            if (modSettingParams.Mandatory.allowNegativeStock)
                return false

        }
    }
    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rate, RowsField.amount, RowsField.netAmt]
        const DCol = [RowsField.dRate, RowsField.dAmount, RowsField.netAmtD, RowsField.convRate, RowsField.discAmtD]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL) {
            if (isDollarInvoice == '0' && DCol.includes(column))
                return false
            else
                return true
        }
        else
            return false
    }
    function CustomColumnMenu(props) {
        return (
            <GridColumnMenu
                {...props}
                slots={{
                    columnMenuColumnsItem: null, // ❌ removes "Manage columns"
                }}
            />
        );
    }

    const columns = [
        {
            field: RowsField.id,
            headerName: "Delete",
            width: 60,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            filterable: false,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div>
                    {/* funIsFooter(row.id) ? <div className="text-center"> Total</div> : */}
                    {
                        <div className="flex justify-evenly" ><h6> {row.id}</h6>
                            <strong>

                                {selPktType == 'SNG' && selBillType == 'P' && !isRefId && row.bPcs <= 0 && row.bWeight <= 0 && !isNewEntry ? "" :

                                    <FontAwesomeIcon
                                        color="red"
                                        className={`cursor-pointer`}
                                        onClick={() => handleDeleteRow(row.id)}
                                        icon={faSquareXmark}
                                    ></FontAwesomeIcon>
                                }
                            </strong>
                        </div>}
                </div>
            ),
        },
        {
            field: RowsField.itemCode,
            headerName: "Item Code",
            minWidth: 80,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,

            renderCell: ({ row }) => (<div>

                {row.itemCode}
            </div>)

        },
        {
            field: RowsField.itemName,
            headerName: "Item Name",
            minWidth: 300,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            filterable: false,
            disableColumnMenu: true,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start" data-grid-autocomplete="true">
                    {/* funIsFooter(row.id) ? "" : */}
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.itemCode)}
                            size="sm"
                            color={"danger"}
                            id={RowsField.itemName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="w-full text-xs"
                            classNames={{
                                base: "min-h-[24px] py-1",
                                title: "text-xs",
                                input: "text-xs",
                            }}
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingData}
                            isReadOnly={selPktType == "MIX" && updateFlag == 0 ? false : setColumnDisable(row)}
                            isVirtualized
                            defaultItems={
                                masterData && masterData.itemMaster ? masterData?.itemMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.itemName)
                            }
                            //onChange={handleFormSelectionChange}
                            selectedKey={row.itemCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Item_Code}
                                    classNames={{
                                        base: "min-h-[24px] py-1",
                                        title: "text-xs whitespace-normal break-words",
                                    }}
                                >
                                    {item.Item_Desc + "(" + item.Item_Code + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }

                </div>
            ),
        },
        {
            field: RowsField.itemDetail,
            headerName: "Item Detail",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            disableColumnMenu: false,
            headerClassName: itemGridHeadClass,
            renderCell: ({ row }) => (
                <div>{renderInputCell(row, RowsField.itemDetail, "text",
                    selPktType == "MIX" && updateFlag == 0 ? false : setColumnDisable(row),
                    "", setColumnRequired(RowsField.itemDetail), "", "")
                }</div>
            )
        },
        {
            field: RowsField.reportNo,
            headerName: "Report No.",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>{renderInputCell(row, RowsField.reportNo, "text",
                    selPktType == 'SNG' && selBillType == 'S' && row.detailId != 0 ? true : selPktType == 'SNG' && selBillType == 'P' && !isNewEntry && row.detailId > 0 ? true : false,
                    "", setColumnRequired(RowsField.reportNo), "", "")
                }</div>
            )
        },
        {
            field: RowsField.lotNo,
            headerName: selPktType != 'SNG' && selTradeOf == 'R' ? "Rought No" : "Lot No",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (

                <div>{
                    (renderInputCell(row, RowsField.lotNo, "text",
                        selPktType == 'SNG' && selBillType == 'S' && row.detailId != 0 ? true : selPktType == 'SNG' && selBillType == 'P' && !isNewEntry && row.detailId > 0 ? true : false,
                        "",
                        setColumnRequired(RowsField.lotNo)
                        , "", ""))
                }</div>

            ),
        },
        {
            field: RowsField.pktNo,
            headerName: "Pkt No",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>{
                    renderInputCell(row, RowsField.pktNo, "text",
                        selPktType == 'SNG' && selBillType == 'S' && row.detailId != 0 ? true : selPktType == 'SNG' && selBillType == 'P' && !isNewEntry && row.detailId > 0 ? true : false,
                        ""
                        , setColumnRequired(RowsField.pktNo)
                        , "", "")
                }</div>
            )
        },
        {
            field: RowsField.shapeName,
            headerName: "Shape",
            minWidth: 200,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            filterable: false,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start" data-grid-autocomplete="true">
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.shapeCode)}
                            size="sm"
                            color={"warning"}
                            id={RowsField.shapeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="w-full"
                            menuTrigger={"input"}
                            isReadOnly={setColumnDisable(row)}
                            isClearable={false}

                            isLoading={isLoadingGridData}
                            // isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.shapeMaster ? gridMasterData?.shapeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.shapeName)
                            }
                            selectedKey={row.shapeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.S_Code}
                                    classNames={{
                                        base: "min-h-[24px] py-1",
                                        title: "text-xs whitespace-normal break-words",
                                    }}
                                >
                                    {item.S_Code + "(" + item.S_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },
        {
            field: RowsField.colorName,
            headerName: "Color",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            filterable: false,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.colorCode)}
                            size="sm"
                            color={"success"}
                            id={RowsField.colorName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row)}
                            // isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.colorMaster ? gridMasterData?.colorMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.colorName)
                            }
                            selectedKey={row.colorCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sh_Code}
                                    classNames={{
                                        base: "min-h-[24px] py-1",
                                        title: "text-xs whitespace-normal break-words",
                                    }}
                                >
                                    {item.Sh_Code + "(" + item.Sh_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>}


                </div>
            ),
        },
        {
            field: RowsField.purityName,
            headerName: "Purity",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            filterable: false,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.purityCode)}
                            size="sm"
                            color={"primary"}
                            id={RowsField.purityName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="w-full"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row)}
                            // isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.purityMaster ? gridMasterData?.purityMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.purityName)
                            }
                            selectedKey={row.purityCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Q_Code}
                                    classNames={{
                                        base: "min-h-[24px] py-1",
                                        title: "text-xs whitespace-normal break-words",
                                    }}
                                >
                                    {item.Q_Code + "(" + item.Q_Name + ")"}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.sizeName,
            headerName: "Size",
            minWidth: 150,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            filterable: false,
            renderCell: ({ row }) => (
                <div className="mt-1 flex items-start">
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.sizeCode)}
                            size="sm"
                            color={"default"}
                            id={RowsField.sizeName}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="w-full"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row)}
                            //  isVirtualized
                            defaultItems={
                                gridMasterData && gridMasterData.sizeMaster ? gridMasterData?.sizeMaster : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.sizeName)
                            }
                            selectedKey={row.sizeCode}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.Sz_Code}
                                    classNames={{
                                        base: "min-h-[24px] py-1",
                                        title: "text-xs whitespace-normal break-words",
                                    }}
                                >
                                    {item.Sz_Name}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }


                </div>
            ),
        },

        {
            field: RowsField.lwRatio,
            headerName: "LxW Ratio",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: true,
            filterable: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        <Autocomplete
                            isRequired={setColumnRequired(RowsField.lwRatio)}
                            size="sm"
                            color={"default"}
                            id={RowsField.lwRatio}
                            eventResizeFeature={true}
                            selectionMode="single"
                            showScrollIndicators={true}
                            placeholder="--Select--"
                            className="max-w-23"
                            menuTrigger={"input"}
                            isClearable={false}
                            isLoading={isLoadingGridData}
                            isReadOnly={setColumnDisable(row)}
                            isVirtualized
                            defaultItems={
                                row[RowsField.objLwRatio] ? row[RowsField.objLwRatio] : []
                            }
                            onSelectionChange={(e) =>
                                handleAutoCompleteChange(e, row.id, RowsField.lwRatio)
                            }
                            selectedKey={row.lwRatio}
                        >
                            {(item) => (
                                <AutocompleteItem
                                    key={item.LwCode}
                                >
                                    {item.LwCode}
                                </AutocompleteItem>
                            )}
                        </Autocomplete>
                    }
                    {/* {
                        funIsFooter(row.id) ? "" : renderInputCell(row, RowsField.lwRatio, "text",
                            setColumnDisable(row),
                            "", false, "", "")
                    } */}
                </div>
            )
        },

        {
            field: RowsField.lab,
            headerName: "Lab",
            minWidth: 110,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>{renderInputCell(row, RowsField.lab, "text",
                    setColumnDisable(row),
                    "", false, "", "")
                }</div>
            )
        },
        {
            field: RowsField.pcs,
            headerName: "Pcs",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>{
                    renderInputCell(row, RowsField.pcs, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )

        },
        {
            field: RowsField.weight,
            headerName: "Weight",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                // funIsFooter(row.id) ? <div className="text-right">{total_Weight}</div>
                <div>{
                    renderInputCell(row, RowsField.weight, "number",
                        setColumnDisable(row),
                        "", true, "", "")
                }</div>
            )
        },
        {
            field: RowsField.dRate,
            headerName: "Rate($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (<div>{
                renderInputCell(row, RowsField.dRate, "number",
                    false,
                    //setColumnDisable(row),
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.dAmount,
            headerName: "Amount($)",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (<div>{
                renderInputCell(row, RowsField.dAmount, "number",
                    true,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.convRate,
            headerName: "Conv. Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (<div>{
                renderInputCell(row, RowsField.convRate, "number",
                    // setColumnDisable(row),
                    false,
                    "", false, "", "")
            }</div>
            )
        },
        {
            field: RowsField.rate,
            headerName: "Rate",
            minWidth: 120,
            flex: 1,
            headerAlign: "center",
            align: "right",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (<div>{
                renderInputCell(row, RowsField.rate, "number",
                    false,
                    // setColumnDisable(row),
                    "", true, "", "")
            }</div>
            )
        },
        {
            field: RowsField.amount,
            headerName: " Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.amount]
                    }
                </div>)
        },
        {
            field: RowsField.discPer,
            headerName: "Disc %",
            width: 85,
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (<div>
                {
                    renderInputCell(row, RowsField.discPer, "number", false, "", false, "", "")
                }
            </div>
            )
        },

        {
            field: RowsField.discAmtD,
            headerName: "Disc Amt($)",
            width: 110,
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.discAmtD, "number", true, "", false, "", "")

                    }
                </div>)
        },
        {
            field: RowsField.discAmt,
            headerName: "Disc Amt",
            width: 110,
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.discAmt, "number", true, "", false, "", "")

                    }
                </div>)
        },
        {
            field: RowsField.stPer,
            headerName: !isStPerDisable ? "CGST %" : "IGST %",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.stPer, "number", false, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.stAmt,
            headerName: !isStPerDisable ? "CGST" : "IGST",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            width: 120,
            headerAlign: "center",
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.stAmt, "number", true, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.astPer,
            headerName: "SGST%",
            width: 85,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.astPer, "number", false, "", false, "", "")}
                </div>
            )
        },
        {
            field: RowsField.astAmt,
            headerName: "SGST",
            width: 120,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            renderCell: ({ row }) => (
                <div>
                    {
                        renderInputCell(row, RowsField.astAmt, "number", true, "", false, "", "")
                    }
                </div>
            )
        },
        {
            field: RowsField.netAmt,
            headerName: "Net Amount",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            headerClassName: itemGridHeadClass,
            disableColumnMenu: false,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {
                        renderInputCell(row, RowsField.netAmt, "number",
                            true,
                            "", true, "", "")
                    }
                    {/* {row[RowsField.netAmt]
                    } */}
                </div>)
        },
        {
            field: RowsField.netAmtD,
            headerName: "Net Amount($)",
            minWidth: 130,
            flex: 1,
            headerAlign: "center",
            disableColumnMenu: false,
            headerClassName: itemGridHeadClass,
            align: "right",
            renderCell: ({ row }) =>
            (
                <div>
                    {row[RowsField.netAmtD]
                    }
                </div>)
        },


    ]
    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}

        // Validate username
        if (formData.vouNo.trim() == "") {
            newErrors[formField.vouNo] = "Invoice No required"
        }

        if (formData[formField.partyId] == "" || formData[formField.partyId] == "0") {
            newErrors[formField.partyId] = "Party Name required"
        }
        if (formData[formField.bookId] == "" || formData[formField.bookId] == "0") {
            newErrors[formField.bookId] = "Book Name required"
        }
        if (formData[formField.deliveryId] == "" || formData[formField.deliveryId] == "0") {
            newErrors[formField.deliveryId] = "Ship To required"
        }

        // if (formData.billNo.trim() == "") {
        //     newErrors[formField.billNo] = "Bill No required"
        // }
        if (formData[formField.billDate] == null || formData[formField.billDate] == "" || formData[formField.billDate] == "Invalid Date") {
            newErrors[formField.billDate] = "Bill Date required"
        }
        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }

    useEffect(() => {
        validateForm();
    }, [formData])

    const ValidateGrid = () => {
        let no = 0
        let msg = ""
        if (rows.length > 0) {
            // const d = rows.filter(ele => ele.id != 100)
            // if (d.length > 0) {
            for (let i = 0; i < rows.length; i++) {

                if (selPktType == 'SNG' && (rows[i].pcs == "" || rows[i].pcs == "0")) {

                    if (!msg.includes("Pcs"))
                        msg = msg + "  Pcs ,";
                    no = 1
                }
                if (rows[i].rate == "" || rows[i].rate == "0") {
                    if (!msg.includes("Rate"))
                        msg = msg + "  Rate ,";
                    no = 1
                }
                if (rows[i].weight == "" || rows[i].weight == "0") {

                    if (!msg.includes("Weight"))
                        msg = msg + "  Weight ,";
                    no = 1
                }
                // if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar) {
                if (isDollarInvoice == '1') {
                    if (rows[i].convRate == "" || rows[i].convRate == "0") {
                        if (!msg.includes("Conv. Rate"))
                            msg = msg + "  Conv. Rate ,";
                        no = 1
                    }
                }
            }
            // }
            // else {
            //     msg = "Add Atleast One  Item"
            //     no = 1
            // }
        }
        else {
            msg = "Add Atleast One  Item"
            no = 1
        }

        if (no)
            return msg + " is required"
        else return ""

    }

    const funSubmit = () => {
        // const validate_form = validateForm()
        // const grid_msg = ValidateGrid()
        // console.log(grid_msg, validate_form)

        // if (grid_msg == "" && validate_form) {

        funAddUpdate({
            data: {
                comp_code: compCode.join(","),
                item_list: rows,
                deleteditem_list: deletedItemRows,
                trans_id: formData[formField.transId],
                bill_type: selBillType,
                trade_of: selTradeOf,
                nos: Number(total_Pcs),
                weight: total_Weight,
                with_bill: isWithBill ? 1 : 0,
                vou_no: formData[formField.vouNo],
                book_id: formData[formField.bookId],
                party_id: formData[formField.partyId],
                delivery_id: formData[formField.deliveryId],
                trade_type: formData[formField.tradeType],
                location_id: formData[formField.locationId],
                docfor: isDollarInvoice == '1' ? '$' : 'RS',
                pkt_type: selPktType == 'SNG' ? selPktType : '',
                broker_id: formData[formField.brokerId],
                bill_no: formData[formField.billNo],
                bill_date: formData[formField.billDate],
                challan_no: !isNewEntry ? formData[formField.chalNo] : formData[formField.vouNo],
                due_days: formData[formField.dueDays],
                remark: formData[formField.remark],
                ref_trn: formData[formField.refTrnId],
                br_per: brokPer && brokPer != "" ? brokPer : 0,
                br_amt: total_BrokAmt,
                br_amtd: total_BrokAmtD,
                tds_per: tdsPer && tdsPer != "" ? tdsPer : 0,
                tds_acid: tdsAcId,
                tds_amt: total_TDSAmt,
                net_amount: net_Amount,
                net_amountd: net_AmountD,
                gross_amt: total_Amount,
                gross_amtd: total_AmountD,
                total_gst: total_GSTtax,
                total_sgst: total_SGSTtax,
                disc_amt: total_disc,
                disc_amtd: total_discD,
                jv_trn_data: JvTrnData,
                mkt_lotno: selPktType == 'SNG' ? isUseMfgNoAsMktno ? 0 : selBillType == 'S' && selTradeOf == 'P' ? '1' : mktLotNo : 0,// isUseMfgNoAsMktno ? '0' : mktLotNo,
                login_userid: user.username,
                rec_status: !isNewEntry ? 1 : 2,
                excel_data: isExcelImport ? excelData : [],
                fystart_date: dayjs(startDate).format("YYYY-MM-DD"),
                fyend_date: dayjs(endDate).format("YYYY-MM-DD")
            }
        })
        // }
        // else {
        //     addToast({
        //         title: "",
        //         description: grid_msg,
        //         color: "danger"
        //     })
        //     submitLockRef.current = false;

        // }

    }
    // const safeSubmit = async () => {
    //     try {
    //         await funSubmit();
    //     } finally {
    //         calledRef.current = false; // 🔓 always release
    //     }
    // };
    const handleSubmit = (e) => {
        e.preventDefault()


        if (!isUseMfgNoAsMktno && selPktType == 'SNG' && selBillType == 'P' && (mktLotNo == '' || mktLotNo == null || mktLotNo == '0')) {
            show("Lot No Series Not Found")
            return;
        }
        const validate_form = validateForm()
        const grid_msg = ValidateGrid()
        if (grid_msg != "" || !validate_form) {
            show(grid_msg)
            return;
        }
        setSubmitBtnId(e.nativeEvent.submitter.id)
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (isNewEntry || (!isNewEntry && funNormalizeInput(formData[formField.billNo]) !== funNormalizeInput(formData[formField.oldBillNo]))) {

            funchkBillNo({
                data: {
                    compcode: compCode.join(","),
                    bill_no: formData[formField.billNo],
                    book_id: formData[formField.bookId],
                    bill_type: selBillType,
                    party_id: selBillType == "P" ? formData[formField.partyId] : "",
                    start_date: dayjs(startDate).format("YYYY-MM-DD"),
                    end_date: dayjs(endDate).format("YYYY-MM-DD"),
                },
                onSuccess: (data) => {
                    if (!submitLockRef.current) return; // 🚫 ignore stale calls

                    if (data && data.length > 0) {

                        setFormData({ ...formData, [formField.billNo]: "" })
                        show(<div>
                            {`Bill No - "${formData[formField.billNo]}" already exist.`}
                            <div className=' m-1 p-2 text-green-700 bg-green-50'> Please enter a new one.</div>
                        </div>)
                        submitLockRef.current = false;
                        return;
                    }
                    //else
                    //  submitLockRef.current = false;
                }
            })
        }
        //  else {
        if (selPktType == 'SNG' && selTradeOf == 'P') {
            const lotPktString = rows
                .filter(item => item.lotNo && item.pktNo && item.detailId == 0)
                .map(item => `${item.lotNo}-${item.pktNo}`)
                .join(",");

            if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                if (selBillType == 'S') {
                    checkStock({
                        data: {
                            compcode: compCode.join(","),
                            list: lotPktString,
                            Ismfglist: 0,
                            tradeof: selTradeOf
                        },
                        onSuccess: (data) => {
                            if (!submitLockRef.current) return; // 🚫 ignore stale calls

                            if (data && data.length > 0) {

                                const result = data
                                    .map(item => `${item.L_Code}-${item.PktNo}`)
                                    .join(",");
                                show(
                                    <div className="text-red-700 text-sm" >Out Of Stock Lot No. & Pkt No.
                                        {<div className="text-gray-700 list-disc ml-5">
                                            {result}
                                        </div>}
                                    </div>)
                                submitLockRef.current = false;
                                return;

                            }
                            else {
                                //  submitLockRef.current = false;
                                funSubmit()
                            }


                        }
                    });
                }
                else if (selBillType == 'P') {
                    funGetDupPktList({
                        data: {
                            compcode: compCode.join(","),
                            list: lotPktString,
                            Ismfglist: 0,
                            Ischkmfgmkt: 0
                        },
                        onSuccess: (data) => {
                            if (!submitLockRef.current) return; // 🚫 ignore stale calls

                            if (data && data.length > 0) {
                                const result = data
                                    .map(item => `${item.L_CODE}-${item.PKTNO}`)
                                    .join(",");
                                show(<div className="text-red-700 text-sm" >Duplicate Stock Lot No. & Pkt No. {<div className="text-gray-700 list-disc ml-5">
                                    {result}
                                </div>}</div>)
                                submitLockRef.current = false;
                                return;

                            }
                            else {
                                // submitLockRef.current = false;
                                funSubmit()
                            }


                        }
                    });
                }
            }
            else
                funSubmit()

        }
        else {
            funSubmit();
        }
        // }
        // const newRows = rows.filter(ele => ele.id != 100)

    }
    useEffect(() => {
        funMktLotNo(dayjs(Date()).format("YYYY-MM-DD"))
    }, [isUseMfgNoAsMktno])


    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams)?.length > 0) {
            //const newData = [...gridData, { id: 100, ...initialRow }].sort((a, b) => a.id - b.id)

            setRows(gridData)


            if (detail &&
                detail?.itemData &&
                detail?.itemData.length > 0) {
                if (detail?.itemData[0]?.Trade_Type == "URD" || detail?.itemData[0]?.Trade_Type == "RD") setIsStPerDisable(false)
                else setIsStPerDisable(true)

                if (detail?.itemData[0]?.Doc_For == '$' || (CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS && detail?.itemData[0]?.Doc_For == '' && selPktType == 'SNG'))
                    setIsDollarInvoice('1')
                else
                    setIsDollarInvoice('0')

                if (detail?.itemData[0]?.Bill_No == "" && selBillType == 'S')
                    funGenBillNo(detail?.itemData[0]?.Account_Id ?? "", true)

                setJvTrnData({
                    trnNo: detail?.itemData[0]?.Trn_No ?? 0,
                    tdsJvTrnNo: detail?.itemData[0]?.TdsjvTrnno ?? 0,
                    tcsJvTrnNo: detail?.itemData[0]?.TcsjvTrnno ?? 0,
                    excAedJvTrnNo: detail?.itemData[0]?.ExcaedjvTrnno ?? 0,
                    excSedJvTrnNo: detail?.itemData[0]?.ExcsedjvTrnno ?? 0,
                    excJvTrnNo: detail?.itemData[0]?.ExcjvTrnno ?? 0,
                    bTrnNo: detail?.itemData[0]?.BTrnno ?? 0
                })
                if (detail?.itemData[0]?.RefTrnId && Number(detail?.itemData[0]?.RefTrnId) > 0)
                    setIsRefId(true)
                setBrokPer(detail?.itemData[0]?.BrPer ?? 0)
                setIsWithBill(detail?.itemData[0]?.BillYN == 1 ? true : false)
                setTdsPer(detail?.itemData[0]?.TdsPer ?? 0)
                setTdsAcId(detail?.itemData[0]?.Tds_AccountId ?? 0)
                setUpdateFlag(detail?.itemData[0]?.Update_Flag ?? 0)
                setFormData({
                    ...formData,
                    [formField.transId]: detail?.itemData[0]?.TransactionId ?? "",
                    [formField.vouNo]: detail?.itemData[0]?.Vou_No ?? "",
                    [formField.chalNo]: detail?.itemData[0]?.Chal_No ?? "",
                    [formField.bookId]: detail?.itemData[0]?.Account_Id ?? "",
                    [formField.brokerId]: detail?.itemData[0]?.Br_Id ?? "",
                    [formField.deliveryId]: detail?.itemData[0]?.D_Id ?? "",
                    [formField.partyId]: detail?.itemData[0]?.Party_Id ?? "",
                    [formField.locationId]: detail?.itemData[0]?.Lac_Id ?? "",
                    [formField.billNo]: detail?.itemData[0]?.Bill_No ?? "",
                    [formField.oldBillNo]: detail?.itemData[0]?.Bill_No ?? "",
                    [formField.billDate]: detail?.itemData[0]?.Bill_Date ?? null,
                    [formField.remark]: detail?.itemData[0]?.Remark ?? "",
                    [formField.tradeType]: detail?.itemData[0]?.Trade_Type ?? "",
                    [formField.pcs]: detail?.itemData[0]?.Pcs ?? "",
                    [formField.weight]: detail?.itemData[0]?.Weight ?? "",
                    [formField.refTrnId]: detail?.itemData[0]?.RefTrnId ?? null,
                    [formField.dueDays]: detail?.itemData[0]?.DueDays ?? 0,
                    [formField.dueDate]: detail.itemData[0]?.DueDays > 0 ? detail.itemData[0]?.Due_Date : detail.itemData[0]?.Bill_Date

                })
            }
        }

    }, [detail, masterData])

    const funGetMasterLink = () => {
        if (selPktType == 'MIX')
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.invoiceEntryMaster
        else
            return naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.invoiceEntryMaster
    }
    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }


    const handleAddRow = () => {
        let new_initialRow = initialRow
        if (modSettingParams && modSettingParams.Visibility) {

            if (Object.keys(modSettingParams.Visibility).length > 0) {
                //set default value to hidden grid column setting based
                const hiddenCol = Object.entries(modSettingParams.Visibility)
                    .filter(([key, value]) => value == false) // filter where value is true
                    .map(([key, value]) => {
                        return { [key]: modSettingParams.Value[key] }
                    });

                const result = hiddenCol.reduce((acc, current) => {
                    return { ...acc, ...current };
                }, {});

                if (result && Object.keys(result).length > 0)
                    new_initialRow = { ...initialRow, ...result }
            }

        }
        let newRowsId = rows.length + 1
        const newRow = { id: newRowsId, ...new_initialRow, }
        // setRows([...rows, newRow])

        if (rows.length == 0) {
            setRows([...rows, newRow
                // , { id: 100, ...new_initialRow }
            ]
            )
        }
        else {
            // newRowsId = rows.filter((ele) => ele.id != 100).length + 1
            const newData = [...rows, { id: newRowsId, ...new_initialRow, }]
            setRows(newData.sort((a, b) => a.id - b.id))
        }

        if (selBillType == "S" && selPktType == "SNG") {
            focusInputCell(newRowsId, RowsField.lotNo)
        }
        else {
            setTimeout(() => {
                const firstCell = gridContainerRef.current?.querySelector(
                    `[data-id="${newRowsId}"] [data-field="id"]`
                );
                if (firstCell) {
                    firstCell.focus();
                }
            }, 500);
        }
        setTimeout(() => {
            const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
            if (gridScroller) {
                gridScroller.scrollLeft = 0; // Scroll to the left
            }
        }, 250)

    }
    const apiRef = useGridApiRef();

    const [focusedRowId, setFocusedRowId] = useState(null);
    useEffect(() => {
        if (gridContainerRef.current) { // make sure ref exists
            if (focusedRowId == RowsField.netAmt) {
                const gridScroller = gridContainerRef.current.querySelector('.MuiDataGrid-virtualScroller');
                if (gridScroller) {
                    gridScroller.scrollLeft = 0;
                }

                const newRow = selectedGridRowId + 2;
                const isLastRow = selectedGridRowId === rows.length - 1;
                // 👉 ADD NEW ROW IF LAST+
                let field = "id"
                if (isLastRow && isNewEntry) {
                    setFocusedRowId("")
                    handleAddRow()
                }

                else {
                    // small timeout to wait for DOM update
                    if (selBillType == 'S' && selPktType == "SNG") {
                        setFocusedRowId("")
                        focusInputCell(newRow, RowsField.lotNo)
                    }
                    else {
                        setTimeout(() => {
                            setFocusedRowId("")
                            const firstCell = gridContainerRef.current.querySelector(
                                `[data-id="${newRow}"] [data-field="id"]`
                            );

                            if (firstCell) {
                                firstCell.focus();
                            }

                        }, 5);
                    }
                }
            }
        }
    }, [focusedRowId, selectedGridRowId]);


    const handleNewAcEntry = () => {
        funLoadMasterData(selTradeOf, selBillType, selPktType)
        // let redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.invoiceEntry.createInvoiceEntry
        // if (selPktType == 'MIX')
        //     redLink = naviCode + btype + "/" + trdtype + "/" + ptype + linksUrl.mixEntry + linksUrl.invoiceEntry.createInvoiceEntry

        // dispatch(setRedirectLink(redLink))
        // navigate(linksUrl.master.account.createAccountMaster)
    }
    const isDisableSubmit = useMemo(() => {
        if (detailParams && Object.keys(detailParams).length > 0) {
            const { status } = detailParams
            if (status == ENUM_STATUS.Pending)
                return false
            else
                return true
        }
        else
            return isPending
    }, [detailParams, isPending])


    useEffect(() => {
        const cleanup = scrollInput({ ignoreRefs: [gridContainerRef] });
        return () => cleanup();
    }, []);


    const disbaleInput = () => {
        //  if (isRefId)
        // return true
        // else
        return false
    }

    const handleDateChange = (newValue) => {

        const cdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                [formField.billDate]: cdate,
            };
        });
        if (cdate && cdate != "Invalid Date") {
            funMktLotNo(cdate)
        }
    }
    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        if (!parsed.isValid()) {
            show("Invalid date format. Use DD/MM/YYYY")
            // toast.error("Invalid date format. Use DD/MM/YYYY", {
            //     position: "top-center",
            //     className: "toast-error"
            // });
            return;
        }

        // ❌ Out of allowed range
        if (parsed.isBefore(minAllowedDate) || parsed.isAfter(maxAllowedDate)) {
            show(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`)
            // toast.error(`Date must be between ${minAllowedDate.format("DD/MM/YYYY")} and ${maxAllowedDate.format("DD/MM/YYYY")}`, {
            //     position: "top-center",
            //     className: "toast-error"
            // });
            setFormData({ ...formData, [name]: null })
            return;
        }

        // Convert to API format
        const formatted = parsed.format("YYYY-MM-DD");

        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };

    const funGetLotNPktNoByStockID = (stockID = "") => {
        const resultData = { l_code: "", pktno: "" };

        const showToast = (id, msg) => {
            if (toast && !toast.isActive(id)) {
                toast.error(msg, {
                    position: "top-center",
                    className: "toast-error",
                    toastId: id,
                });
            }
        };

        const resetFileInput = () => {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        };

        if (!stockID.trim()) {
            return resultData;
        }



        const [lotNo, pktNo] = stockID.split(stockIdSplitter || '-');

        if (lotNo && pktNo) {
            resultData.l_code = lotNo.trim();
            resultData.pktno = pktNo.trim();
        } else {
            show(`Invalid StockID Format: LotNo & PktNo must be separated by ' ${stockIdSplitter || '-'} '`);
            resetFileInput();
        }

        if (!resultData.l_code || !resultData.pktno) {
            showToast("stkinkval", "StockID not found or invalid format");
            resetFileInput();
        }

        return resultData;
    };

    const transformExcelData = (excelRows, excelColMapping) => {
        return excelRows.map(row => {
            const rowObj = {};

            excelColMapping.forEach(mapping => {
                const colIndex = parseInt(mapping.xl_col_no) - 1; // Convert to 0-based index
                rowObj[mapping.tb_col_name] = row[colIndex] ?? null;
            });

            return rowObj;
        });
    };
    const handleImportByStockId = (value) => {
        setIsImportByStockId(value)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''; // Clear file input
        }
        setIsSameItem(false)
        setIsWithBill(false)
        setRows([])
    }
    //console.log(excelData, "ex", rows)
    const handlePurchaseTypeUpload = (dataRows) => {
        const excelData = transformExcelData(dataRows, excelTempData);
        const updatedExcelData = excelData.map((row) => {
            if (isImportByStockId) {
                const stockData = funGetLotNPktNoByStockID(row.stoneid ?? "");

                return {
                    ...row,
                    l_code: stockData?.l_code ?? null,
                    pktno: stockData?.pktno ?? null,
                };
            }

            return row;
        });
        setExcelData(updatedExcelData);

        const newRows = updatedExcelData.map((item, ind) => {
            let {
                s_code, sha_code, q_code, sz_code, crate, amount, amountd, discper,
                l_code, pktno, bweight, brate, brated, labid, stoneid, reportno,
            } = item;

            // if (isImportByStockId) {
            //     const stockData = funGetLotNPktNoByStockID(stoneid ?? "");
            //     l_code = stockData.l_code;
            //     pktno = stockData.pktno;
            // }

            const getCode = (master, field, nameKey, codeKey) => {
                const name = item?.[field] ?? "";
                const matched = master?.filter(ele =>
                    String(ele[nameKey] ?? "").toLowerCase() === String(name).toLowerCase()
                );
                return matched?.length ? matched[0][codeKey] : "";
            };

            const t_scode = getCode(gridMasterData?.shapeMaster, "s_code", "S_Name", "S_Code");
            const t_shacode = sha_code?.trim() ? getCode(gridMasterData?.colorMaster, "sha_code", "Sh_Name", "Sh_Code") || "*" : '';
            const t_qcode = getCode(gridMasterData?.purityMaster, "q_code", "Q_Name", "Q_Code");
            const t_szcode = getCode(gridMasterData?.sizeMaster, "sz_code", "Sz_Name", "Sz_Code");

            const f_amount = amount || parseFloat(bweight ?? 0) * parseFloat(brate ?? 0);
            const f_amountD = amountd || parseFloat(bweight ?? 0) * parseFloat(brated ?? 0);

            const updateRow = {
                id: ind + 1,
                ...initialRow,
                [RowsField.lotNo]: l_code || "",
                [RowsField.pktNo]: pktno || "",
                [RowsField.detailId]: 0,
                [RowsField.itemCode]: "",
                [RowsField.itemName]: "",
                [RowsField.shapeName]: s_code,
                [RowsField.shapeCode]: t_scode,
                [RowsField.reportNo]: reportno,
                [RowsField.purityName]: q_code,
                [RowsField.purityCode]: t_qcode,
                [RowsField.colorName]: sha_code,
                [RowsField.colorCode]: t_shacode,
                [RowsField.sizeName]: sz_code,
                [RowsField.sizeCode]: t_szcode,
                [RowsField.lwRatio]: "",
                [RowsField.rate]: brate || 0,
                [RowsField.lab]: labid || '',
                [RowsField.amount]: 0,
                [RowsField.pcs]: 1,
                [RowsField.discPer]: discper || 0,
                [RowsField.weight]: bweight || 0,
                [RowsField.oldWeight]: 0,
                [RowsField.oldPcs]: 0,
                [RowsField.bPcs]: 0,
                [RowsField.convRate]: crate || 0,
                [RowsField.reportNo]: reportno || '',
                [RowsField.dRate]: brated || 0,
                [RowsField.dAmount]: 0,
                [RowsField.bWeight]: 0,
                [RowsField.itemDetail]: "",
                [RowsField.objLwRatio]: [],
            };
            const calData = funCalAllAmount([updateRow], 0, 0, 0, brated > 0 ? RowsField.dRate : RowsField.rate)
            console.log(calData, "calDtaa")
            return {
                ...updateRow, amount: calData?.amount, dAmount: calData?.dAmount, netAmt: calData?.netAmt, netAmtD: calData?.netAmtD
                , discAmt: calData?.discAmt, discAmtD: calData?.discAmtD, rate: calData?.rate, dRate: calData?.dRate

            }
        });

        if (newRows && newRows.length > 0) {
            let lotPktString = newRows
                .map(item => `${item.lotNo}-${item.pktNo}`)
                .join(",");

            if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                funGetDupPktList({
                    data: {
                        compcode: compCode.join(","),
                        list: lotPktString,
                        Ismfglist: 0,
                        Ischkmfgmkt: 0
                    },
                    onSuccess: (data) => {

                        if (data && data.length > 0) {
                            const result = data
                                .map(item => `${item.L_CODE}-${item.PKTNO}`)
                                .join(",");
                            show(<div className="text-red-700 text-sm" >Duplicate Stock Lot No. & Pkt No. {<div className="text-gray-700 list-disc ml-5">
                                {result}
                            </div>}</div>)
                            setExcelColMap(prev => [
                                ...prev,
                                { msg: `${result},` },
                            ]);

                            const filtered = newRows.filter(item =>
                                !data.some(ex =>
                                    ex.PKTNO === item.pktNo && ex.L_CODE === item.lotNo
                                )
                            );
                            setRows(filtered)

                        }
                        else {
                            setRows(newRows);
                        }


                    }
                });
            }
        }
        // setRows(newRows);

        // excelData.forEach((item, index) => {
        //     setSelectedGridRowId(index);
        //     funChkPktLotNo({
        //         data: {
        //             compcode: compCode.join(","),
        //             lotno: item?.l_code,
        //             pktno: item?.pktno,
        //             mktlcode: mktLotNo || '0'
        //         },
        //         onSuccess: (data) => {

        //             onSuccessChkPktLotNo(data, index, newRows);
        //             if (data && data.length > 0) {
        //                 if (data[0].count > 0)
        //                     setExcelColMap(prev => [
        //                         ...prev,
        //                         { msg: `lot No : ${item.l_code} & Pkt No : ${item.pktno}` },
        //                     ]);
        //             }


        //         }

        //     });
        // });
    };
    const validateImportBykeys = (data, importByStockId) => {
        if (importByStockId) {
            // stoneid is required
            return data.every(
                item => item.stoneid !== null && item.stoneid !== undefined && item.stoneid !== ''
            );
        } else {
            // l_code and pktno are required
            return data.every(
                item =>
                    item.l_code !== null && item.l_code !== undefined && item.l_code !== '' &&
                    item.pktno !== null && item.pktno !== undefined && item.pktno !== ''
            );
        }
    };

    const handleSellTypeUpload = (dataRows) => {

        const uploadEXLData = transformExcelData(dataRows, excelTempData);
        const valid = validateImportBykeys(uploadEXLData, isImportByStockId)
        if (!valid) {
            show(`${isImportByStockId ? "Stock Id Value Should Not Be Empty" : "Lot No & Pkt No Value Should Not Be Empty "}`)
            // toast.error(`${isImportByStockId ? "Stock Id Value Should Not Be Empty" : "Lot No & Pkt No Value Should Not Be Empty "}`, {
            //     "position": "top-center",
            //     className: "toast-error"
            // })
            return
        }

        setExcelData(uploadEXLData);
        const mappedData = uploadEXLData.map((item, ind) => {
            let {
                l_code, pktno, brate, brated, stoneid,
            } = item;

            if (isImportByStockId) {
                const lotpkt = funGetLotNPktNoByStockID(stoneid);
                return { ...lotpkt, brate, brated, stoneid }
            }

            return { l_code, pktno, brate, brated, stoneid, }

        }).filter(row => row.l_code || row.pktno);


        const newRowMap = new Map(
            mappedData.map(row => [`${row?.l_code}-${row?.pktno}`, row])
        );
        if (mappedData && mappedData.length > 0) {
            const lotPktString = mappedData
                .map(item => `${item.l_code}-${item.pktno}`)
                .join(",");
            if (lotPktString && lotPktString.length != "" && lotPktString.length > 0) {
                findStockWithPosition({
                    data: {
                        compcode: compCode.join(","),
                        list: lotPktString,
                        Ismfglist: 0,
                        Ischkmfgmkt: 0
                    },
                    onSuccess: (data) => {
                        if (data && data.length > 0) {
                            const Stockdata = data.filter((ele) => ele.InStock == 1)
                            const OutStockdata = data.filter((ele) => ele.InStock == 0)
                            if (OutStockdata && OutStockdata.length > 0) {
                                const result = OutStockdata
                                    .map(item => `${item.LotPkt}`)
                                    .join(",");
                                show(<div className="text-red-700 text-sm" >Out Of Stock Lot No. & Pkt No. {<div className="text-gray-700 list-disc ml-5">
                                    {result}
                                </div>}</div>)
                                setExcelColMap(prev => [
                                    ...prev,
                                    { msg: `${result},` },
                                ]);
                            }
                            const dd = Stockdata.map((ele, ind) => {
                                const key = `${ele.LotNo}-${ele.PktNo}`;
                                const existingRow = newRowMap.get(key);

                                const hasManualRate =
                                    (existingRow?.brated ?? 0) > 0 ||
                                    (existingRow?.brate ?? 0) > 0;
                                const calData = funCalAllAmount([{
                                    ...existingRow, [RowsField.weight]: ele.BWeight, [RowsField.pcs]: ele.BPcs, [RowsField.dRate]: hasManualRate
                                        ? existingRow?.brated || 0
                                        : (ele?.BRated || 0),

                                    [RowsField.rate]: hasManualRate
                                        ? existingRow?.brate || 0
                                        : (ele?.BRate || 0),
                                }], 0, 0, 0, "")

                                return {
                                    id: ind + 1,
                                    ...initialRow,
                                    [RowsField.lotNo]: ele.LotNo,
                                    [RowsField.pktNo]: ele.PktNo,
                                    [RowsField.itemCode]: ele.ItemCode,
                                    [RowsField.shapeCode]: ele.ShapeCode,
                                    [RowsField.sizeCode]: ele.SizeCode,
                                    [RowsField.colorCode]: ele.ColorCode,
                                    [RowsField.purityCode]: ele.PurityCode,
                                    [RowsField.reportNo]: ele.ReportNo,
                                    [RowsField.lab]: ele.Lab,
                                    [RowsField.lwRatio]: ele.LwRatio,
                                    [RowsField.pcs]: ele.BPcs,
                                    [RowsField.weight]: ele.BWeight,
                                    [RowsField.sLotNo]: ele.SLotNo,
                                    [RowsField.sPktNo]: ele.SPktNo,
                                    //if excelhas rate
                                    [RowsField.dRate]: hasManualRate
                                        ? existingRow?.brated || 0
                                        : (ele?.BRated),

                                    [RowsField.rate]: hasManualRate
                                        ? existingRow?.brate || 0
                                        : (ele?.BRate),

                                    [RowsField.amount]: calData.amount,
                                    [RowsField.dAmount]: calData.dAmount,
                                    [RowsField.netAmt]: calData.netAmt,
                                    [RowsField.netAmtD]: calData.netAmtD

                                };
                            });
                            setRows(dd)
                        }
                        // if (data && data.length > 0) {
                        //     // console.log(Stockdata)
                        //     const newExcelColMap = [];

                        //     data.forEach((item, i) => {
                        //         if (item.InStock == 1) {
                        //             funSetSNGStockData([item], i, newRows, true);
                        //         } else {
                        //             newExcelColMap.push({
                        //                 msg: `${item.LotPkt}`,
                        //                 // msg: `lot No : ${item.LotNo} & Pkt No : ${item.PktNo}`,
                        //             });

                        //             funSetSNGStockData([], i, newRows, true);
                        //         }
                        //     });

                        //     // single state update (important)
                        //     setExcelColMap(prev => [...prev, ...newExcelColMap]);
                        // }
                        //const OutStockdata = data.filter((ele) => ele.IsOutOfStock == 1)



                        // console.log(data)
                    }
                })
            }
        }

    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        setExcelColMap([]); // Reset column map before reading

        reader.onload = (event) => {
            const binaryStr = event.target.result;
            const workbook = XLSX.read(binaryStr, { type: 'binary' });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            if (!rows?.length) return;

            //const dataRows = rows.slice(1);
            const dataRows = rows.slice(1).filter((r) => r.length !== 0);
            const headers = rows[0]; // Not used here but might be needed elsewhere

            if (selBillType === 'S') {
                handleSellTypeUpload(dataRows);
            } else if (selBillType === 'P') {
                handlePurchaseTypeUpload(dataRows);
            }
        };

        reader.readAsBinaryString(file);

        // Reset file input so re-selecting same file triggers onChange
        e.target.value = null;
    };

    const handleExcelCheckChange = (value) => {
        setIsExcelImport(value)
        if (!value)
            setRows([])
    }

    const handleErrors = () => {
        if (ExcelColMap.length === 0) return;

        // const fullMessage = ExcelColMap.map((ele) => {
        //     return selBillType === 'P'
        //         ? `• ${ele.msg}`
        //         : `•  ${ele.msg}`;
        // }).join('\n');
        const fullMessage = ExcelColMap.map((ele) => {
            return selBillType === 'P'
                ? <h2>• {ele.msg}</h2>
                : <h2>•  {ele.msg} </h2>;
        })

        show(<div><h2>{selBillType === 'P' ? ' Duplicate Lot No & Pkt No Not Allowed : ' : ' Out Of Stock  Lot & Pkt No.  '} </h2>
            <div className="bg-yellow-50 p-2 flex gap-2" >{fullMessage}</div></div>)
        // toast.warning(`${selBillType === 'P' ? ' Duplicate Lot No & Pkt No Not Allowed : ' : 'Stock Not Found For : '}  \n ${fullMessage}`, {
        //     position: "top-center",
        //     className: "text-sm whitespace-pre-line p-2  text-gray-700", // preserve line breaks
        //     toastId: "excel-warnings",
        //     icon: false // single toast ID to prevent duplicates
        // });

    }
    function CustomFooter() {
        const apiRef = useGridApiContext();
        const visibleRowIds = apiRef.current.getSortedRowIds();

        // ----------------------------
        // 1) Track synced scroll & grid width
        // ----------------------------
        const [scrollLeft, setScrollLeft] = useState(0);
        const [containerWidth, setContainerWidth] = useState(0);

        // Sync scroll from main grid
        useEffect(() => {
            const scroller = document.querySelector('.MuiDataGrid-virtualScroller');
            if (!scroller) return;

            const handleScroll = () => setScrollLeft(scroller.scrollLeft);
            scroller.addEventListener("scroll", handleScroll);

            return () => scroller.removeEventListener("scroll", handleScroll);
        }, []);

        // Track actual total column width to prevent right side cutoff
        useEffect(() => {
            const colContainer = document.querySelector('.MuiDataGrid-columnsContainer');
            if (!colContainer) return;

            const updateWidth = () => setContainerWidth(colContainer.scrollWidth);

            updateWidth();

            const observer = new ResizeObserver(updateWidth);
            observer.observe(colContainer);

            return () => observer.disconnect();
        }, []);

        // ----------------------------
        // 2) Visible rows & columns
        // ----------------------------
        const visibleRows = useMemo(() => {
            return visibleRowIds.map((id) =>
                apiRef.current.getRowWithUpdatedValues(id)
            );
        }, [apiRef, visibleRowIds]);

        const VisibleCol = apiRef.current.getAllColumns()

        //console.log(VisibleCol)
        // ----------------------------
        // 3) Totals calculation
        // ----------------------------
        const totals = useMemo(() => {
            const result = {};

            VisibleCol.forEach((col) => {
                if (col.type === "number") {
                    const sum = visibleRows.reduce(
                        (acc, row) => acc + parseFloat((row[col.field] || 0)),
                        0
                    );

                    if ([RowsField.pcs].includes(col.field)) {
                        result[col.field] = sum.toFixed(0);
                    } else if ([RowsField.weight].includes(col.field)) {
                        result[col.field] = sum.toFixed(3);
                    } else {
                        result[col.field] = sum.toFixed(2);
                    }
                } else {
                    result[col.field] = "";
                }
            });

            return result;
        }, [VisibleCol, visibleRows, rows]);

        // ----------------------------
        // Render: Scroll-synced footer
        // ----------------------------
        return (
            <Box>
                {/* TOTAL FOOTER ROW (scroll synced + full width) */}
                <Box
                    display="grid"
                    gridTemplateColumns={VisibleCol
                        .map(col => `${col.computedWidth}px`)
                        .join(" ")}
                    width={containerWidth || "100%"}   // EXACT data width
                    position="relative"
                    left={-scrollLeft}                 // Horizontal sync
                    bgcolor="#FFFFFF"
                    color="#c56b05ff"

                    p={1}
                >
                    {VisibleCol.map((col, index) => (
                        <Box
                            key={col.field}
                            fontWeight="bold"
                            textAlign="right"
                            fontSize="11px"
                            textTransform="uppercase"
                            pr={1}
                        >
                            {col.type === "number" ? (
                                <>
                                    <div style={{ fontSize: 10 }}>{col.headerName}</div>
                                    <div>{totals[col.field]}</div>
                                </>
                            ) : (
                                index === 0 ? "TOTAL" : ""
                            )}
                        </Box>
                    ))}
                </Box>

                <GridPagination />
            </Box>
        );

    }
    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, selBillType == 'S' ? "SaleInvoiceUploadFormat.xlsx" : "PurchaseInvoiceUploadFormat.xlsx");


    }

    const handleExportDetail = () => {
        setIsExportDetails(true)
        setOpenDrawer(true)
    }

    // const searchInAllKeys = (data, searchText) => {
    //     if (!searchText) return data;

    //     const lowerSearch = searchText.toLowerCase();

    //     return data.filter(item =>
    //         Object.values(item).some(val =>
    //             val !== null &&
    //             val !== undefined &&
    //             val.toString().toLowerCase().includes(lowerSearch)
    //         )
    //     );
    // };

    // useEffect(() => {
    //     const searchData = searchInAllKeys(allRows, searchText)

    //     setRows(searchData)

    // }, [searchText])
    if (isPending) {
        console.log("ispe", isPending)
        return <LoadingCard />;
    }
    if (isError || isErrorDetail) {
        return <ErrorCard />;
    }

    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} ${entryLabel}   Invoice Entry - ${selPktType == 'SNG' ? "Single Packet" : selPktType}`}
                breadcrumbs={[selBillType == 'S' ? "Sale" : 'Purchase', entryLabel, "Invoice Entry", selPktType == 'SNG' ? "Single Packet" : selPktType]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className={stickyParentClass}>
                    <Drawer height="100%" width="100%" open={openDrawer} anchor="top"
                        variant="temporary"
                        PaperProps={{
                            sx: {
                                height: '100vh',
                                width: '100vw',
                            },
                        }}>
                        <div>


                            {isExportDetails ? <div>
                                <div className="sticky top-0 z-50 w-full bg-blue-600 border-b-2 border-blue-700 py-2">
                                    <div className="text-center font-semibold text-lg text-white uppercase">
                                        Export Details
                                    </div>

                                    <FontAwesomeIcon
                                        icon={faSquareXmark}
                                        className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-3xl text-white hover:text-red-300 transition-colors"
                                        onClick={() => setOpenDrawer(false)}
                                    />
                                </div>
                                <ExportDetailEntry detailParam={detailParams || {}} />

                            </div> :
                                <div>
                                    <div className="w-full bg-gray-100 border-b-2 border-gray-900 flex justify-between font-semibold" >
                                        <div className="text-center ml-5"> Invoice </div> <FontAwesomeIcon
                                            className=" p-2 cursor-pointer text-2xl" icon={faSquareXmark}
                                            onClick={() => setOpenDrawer(false)} ></FontAwesomeIcon></div>
                                    <ReportViewer props_ReportType={enum_Report_Type.INVOICE} />
                                </div>
                            }
                        </div>
                    </Drawer>
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            {
                                Object.keys(inputBoxes).map((key, ind) => (
                                    <div key={key + ind}>
                                        {/* ${isMobile ? 'flex-wrap' : ''} */}
                                        <div className={`flex flex-wrap sm:flex-nowrap md:flex-nowrap    gap-4 align-top items-baseline mb-2 `}>
                                            {
                                                inputBoxes[key].map((item, indx) =>
                                                    item.type == ENUM_INPUT_TYPE.select ? (
                                                        <></>
                                                    ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                        <>
                                                            <Autocomplete
                                                                size="md"
                                                                name={item.name}
                                                                isInvalid={errors[item.name]}
                                                                errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                isLoading={isLoadingData}
                                                                menuTrigger={"input"}
                                                                className="max-w-23 font-semibold  text-xs"
                                                                classNames={{
                                                                    label: "text-xs text-red-500",
                                                                }}
                                                                isClearable={false}
                                                                isVirtualized
                                                                isReadOnly={disbaleInput() ? true : false}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, '', item.name)
                                                                }
                                                                variant={[formField.bookId, formField.partyId, formField.deliveryId].includes(item.id) ? "flat" : "bordered"}
                                                                color={item.id == formField.bookId ? "success" : [formField.partyId, formField.deliveryId].includes(item.id) ? "danger" : ""}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                            {item.name == formField.partyId || item.name == formField.brokerId ?
                                                                <Chip className="cursor-pointer bg-orange-300" color={"default"} onClick={handleNewAcEntry}>
                                                                    <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
                                                                </Chip>
                                                                : ""}
                                                        </>
                                                    ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                        <div className=" w-full flex items-center">
                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                <DatePicker
                                                                    label={item.placeholder}
                                                                    views={["day", "month", "year"]}
                                                                    format="DD/MM/YYYY"
                                                                    isReadOnly={disbaleInput() ? true : false}
                                                                    minDate={minAllowedDate}
                                                                    maxDate={maxAllowedDate}
                                                                    value={
                                                                        formData[item.name]
                                                                            ? dayjs(formData[item.name], "YYYY-MM-DD")
                                                                            : formData[item.name]
                                                                    }
                                                                    onChange={(newValue) => handleDateChange(newValue)}
                                                                    // setFormData((prev) => {
                                                                    //     return {
                                                                    //         ...prev,
                                                                    //         [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                    //             dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                    //     };
                                                                    // });
                                                                    //}}
                                                                    //isRequired={item.required}
                                                                    className="w-full "
                                                                    slotProps={{
                                                                        textField: {
                                                                            size: "small", error: errors[item.name], helperText: errors[item.name],
                                                                            onBlur: (e) => handleDateBlur(e, item.name), required: true
                                                                        },
                                                                    }}
                                                                />
                                                            </LocalizationProvider>
                                                        </div>
                                                    ) : (

                                                        <Input
                                                            type={item.type}
                                                            name={item.name}
                                                            id={item.name}
                                                            isInvalid={errors[item.name]}
                                                            errorMessage={errors[item.name]}
                                                            placeholder={item.placeholder}
                                                            label={item.placeholder}
                                                            labelPlacement="outside"
                                                            isRequired={item.isrequired}
                                                            value={formData[item.name]}
                                                            variant="bordered"
                                                            onChange={(e) => handleChange(e)}
                                                            onBlur={(e) => hanldeBlur("", e)}
                                                            isReadOnly={(item.name == formField.vouNo || disbaleInput())
                                                                && (item.name != formField.billNo || item.name != formField.billDate) ? true : false}
                                                            size={"md"}
                                                            classNames={{
                                                                label: "text-xs text-black font-bold",
                                                            }}
                                                        ></Input>
                                                    )
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="bg-stone-50 px-2 align-center py-1 mb-1 uppercase rounded-sm border-slate-300 border-dashed border-1">
                                <div className="text-center  items-center w-full  flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-between">
                                    {!isNewEntry ?
                                        <div className="flex justify-start mb-2">
                                            <Button
                                                color="default"
                                                size="sm"
                                                variant="shadow"
                                                // isLoading={isPending}
                                                onPress={handleExportDetail}
                                                //isDisabled={isDisableSubmit}
                                                className="text-white  bg-blue-600 mt-1  uppercase font-semibold"
                                                startContent={<FontAwesomeIcon className=" text-md text-white" icon={faExplosion} />}
                                            >Export Detail</Button>
                                        </div> : "-"}
                                    <div className="flex flex-wrap gap-2 justify-end  pr-2 items-center">
                                        <div className="flex flex-nowrap gap-2">
                                            <div
                                                className={` flex items-center px-1  rounded-lg border transition-all duration-200
                                             ${isWithBill
                                                        ? "bg-orange-100 border-orange-400 shadow-sm"
                                                        : "bg-orange-50 border-gray-200 hover:border-orange-300 hover:bg-orange-50"
                                                    }
                                            `}
                                            >
                                                <Checkbox
                                                    size="md"
                                                    color="secondary"
                                                    isSelected={isWithBill}
                                                    onValueChange={handleCheckChange}
                                                    classNames={{
                                                        base: "m-0",
                                                        wrapper:
                                                            "border-2 border-orange-400 rounded-md " +
                                                            "after:bg-orange-600 after:border-orange-600",
                                                        label:
                                                            "text-sm font-semibold " +
                                                            (isWithBill
                                                                ? "text-orange-700"
                                                                : "text-gray-600"),
                                                    }}
                                                >
                                                    WITH BILL
                                                </Checkbox>
                                            </div>
                                            <div className={` flex items-center gap-3 px-2 rounded-lg border transition-all duration-200 ${CurrencySetting === ENUM_CURRENCY_SETTING_VAL.DUAL ? "bg-violet-50 border-violet-300 hover:border-violet-300" : "bg-gray-100 border-gray-200 opacity-70"} `} >
                                                {/* Label */} <h6 className="text-xs text-violet-700 font-semibold whitespace-nowrap uppercase"> Currency: </h6> {/* Currency Options */}
                                                <RadioGroup label="" size="sm" color="secondary" isDisabled={CurrencySetting !== ENUM_CURRENCY_SETTING_VAL.DUAL} value={isDollarInvoice}
                                                    onValueChange={setIsDollarInvoice} orientation="horizontal" className="h-6" classNames={{ wrapper: "gap-1", }} >
                                                    <Radio value="1" classNames={{
                                                        base: `m-0 px-2 py-0.5 rounded-md cursor-pointer transition-all duration-200 
                                                    ${isDollarInvoice === "1" ? "bg-violet-600 shadow-sm" : "bg-white hover:bg-violet-100"} `,
                                                        label: ` text-sm font-bold ${isDollarInvoice === "1" ? "text-white" : "text-violet-700"} `,
                                                        //control: "hidden",
                                                    }} > $ </Radio>
                                                    <Radio value="0" classNames={{
                                                        base: ` m-0 px-2 py-0.5 rounded-md cursor-pointer transition-all duration-200 
                                                        ${isDollarInvoice === "0" ? "bg-violet-600 shadow-sm" : "bg-white hover:bg-violet-100"} `,
                                                        label: ` text-sm font-bold ${isDollarInvoice === "0" ? "text-white" : "text-violet-700"} `,
                                                        //control: "hidden",
                                                    }} > ₹ </Radio>
                                                </RadioGroup> </div>
                                        </div>

                                        {
                                            selTradeOf == 'P' && selPktType == 'SNG' && isNewEntry ?
                                                <div className="flex flex-nowrap  items-center my-0 justify-end gap-3   items-center  ">
                                                    <div>
                                                        <Checkbox
                                                            size="md"
                                                            isSelected={isExcelImport}
                                                            onValueChange={handleExcelCheckChange}
                                                            color="primary"
                                                            classNames={{
                                                                base: `
                                                                m-0 h-8 px-3
                                                                rounded-lg
                                                                border
                                                                transition-all duration-200
                                                                ${isExcelImport
                                                                        ? "bg-rose-100 border-rose-400 shadow-sm"
                                                                        : "bg-white border-rose-200 hover:bg-rose-50 hover:border-rose-300"
                                                                    }
        `,
                                                                wrapper: `
                                                                                    w-5 h-5
                                                                                    border-2 border-rose-500
                                                                                    rounded-md
                                                                                    after:bg-rose-600
                                                                                    after:border-rose-600
        `,
                                                                label: `
            text-xs font-semibold whitespace-nowrap
            ${isExcelImport
                                                                        ? "text-rose-700"
                                                                        : "text-rose-600"
                                                                    }
        `,
                                                            }}
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faFileExcel}
                                                                className="mr-2 text-rose-600"
                                                            />
                                                            Import From Excel
                                                        </Checkbox>
                                                    </div>
                                                    {isExcelImport && <Checkbox
                                                        size="md"
                                                        isSelected={isImportByStockId}
                                                        onValueChange={handleImportByStockId}
                                                        color="primary"
                                                        classNames={{
                                                            base: `
            m-0 h-8 px-3
            rounded-lg
            border
            transition-all duration-200
            ${isImportByStockId
                                                                    ? "bg-sky-100 border-sky-400 shadow-sm"
                                                                    : "bg-white border-sky-200 hover:bg-sky-50 hover:border-sky-300"
                                                                }
        `,
                                                            wrapper: `
            w-5 h-5
            border-2 border-sky-500
            rounded-md
            after:bg-sky-600
            after:border-sky-600
        `,
                                                            label: `
            text-xs font-semibold whitespace-nowrap
            ${isImportByStockId
                                                                    ? "text-sky-700"
                                                                    : "text-sky-600"
                                                                }
        `,
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faCircleArrowUp}
                                                            className="mr-2 text-sky-600"
                                                        />
                                                        Import By Stock ID
                                                    </Checkbox>}

                                                </div>
                                                : ""}
                                    </div>
                                </div>

                                {isExcelImport ? <div className="flex flex-nowrap my-2 items-center justify-end gap-5">

                                    {isImportByStockId ?
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Typography
                                                sx={{
                                                    fontSize: "0.8rem",
                                                    fontWeight: 600,
                                                    color: "#be079c"
                                                }}
                                            >
                                                StockId Splitter:
                                            </Typography>

                                            <ToggleButtonGroup
                                                value={stockIdSplitter}
                                                exclusive
                                                onChange={(e, val) => val && setStockIdSplitter(val)}
                                                size="small"
                                                color="secondary"
                                                sx={{
                                                    height: 25,

                                                    '& .MuiToggleButton-root': {
                                                        px: 1.5,
                                                        py: 0.1,
                                                        fontSize: "1.1rem",
                                                        fontWeight: 600,
                                                        textTransform: "none",
                                                        border: '1px solid #be079c',
                                                        borderRadius: 0
                                                    },

                                                    // vertical divider
                                                    '& .MuiToggleButton-root:not(:last-of-type)': {
                                                        borderRight: '1px solid #be079c'
                                                    },

                                                    '& .Mui-selected': {
                                                        backgroundColor: '#800471 !important',
                                                        color: '#ffffff !important',

                                                        '&:hover': {
                                                            backgroundColor: '#840675b1'
                                                        }
                                                    }
                                                }}
                                            >
                                                <ToggleButton value="#">#</ToggleButton>
                                                <ToggleButton value="-">-</ToggleButton>
                                            </ToggleButtonGroup>
                                        </Box> : ""}
                                    <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className=" h-7"
                                        startContent={<FontAwesomeIcon icon={faDownload} />} >
                                        Import Excel Format
                                    </Button>
                                </div> : ""}
                            </div>
                            <div>
                                {selTradeOf == 'P' && selPktType == 'SNG' && isNewEntry && isExcelImport ?
                                    <div className=" p-2">
                                        <div>
                                            {isLoadingDupPktList || isPendingStkPos ? <div className=" flex gap-1 p-2 justify-center font-semibold border-0 b-red-500 text-pink-700 text-center ">
                                                <h2 className=" px-2" >Proccessing....</h2>
                                                <Spinner size="sm" label="" className="" variant="simple" color="danger" labelColor="danger" />
                                            </div> : ""}
                                            <Input type="file" color="success" size="md" variant="flat"
                                                ref={fileInputRef}
                                                // className="w-1/2"
                                                classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                                // isRequired={isExcelImport}
                                                label="Import From Excel" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>
                                        </div>
                                        <div className="">
                                            {ExcelColMap && ExcelColMap.length > 0 ? (
                                                <div className=" flex gap-2 items-center m-2">
                                                    <Chip className="bg-red-200 text-sm cursor-pointer text-red-700" onClick={handleErrors} >
                                                        <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle}></FontAwesomeIcon>
                                                        View Warnings
                                                    </Chip>

                                                    {
                                                        stkWithPosData?.length > 0
                                                            ? (() => {
                                                                const outStockCount = stkWithPosData.reduce(
                                                                    (count, ele) => count + (ele.InStock === 0 ? 1 : 0),
                                                                    0
                                                                );
                                                                return outStockCount > 0 ? <div className="p-1 text-sm font-semibold text-red-500 bg-red-50"> Total out-of-stock packets: {outStockCount}</div> : "";
                                                            })()
                                                            : ""
                                                    }
                                                    {
                                                        dupPktList?.length > 0
                                                            ? (() => {
                                                                const dupStockCount = dupPktList?.length
                                                                return dupStockCount > 0 ? <div className="p-1 text-sm font-semibold text-red-500 bg-red-50">Total Duplicate Lot & packets: {dupStockCount}</div> : "";
                                                            })()
                                                            : ""
                                                    }
                                                </div>

                                            ) : null}
                                        </div>
                                        {/* <h2 className="text-xs p-2 text-gray-300">{`In Excel Lot No Must Be In Column  ${ExcelColMap[0]?.lcode || " "}  & PktNo Must Be In Column:${ExcelColMap[0]?.pktno || " "} `}</h2> : ""} */}
                                    </div> : ""}
                            </div>

                            <div>
                                <div className="flex flex-wrap sm:flex-nowrap md:flex-nowrap justify-between items-center">
                                    <div className="flex flex-nowrap w-full gap-5 items-center justify-start">
                                        {
                                            isRefId ? "-" :
                                                <Button
                                                    size="sm"
                                                    radius="md"
                                                    onPress={handleAddRow}
                                                    startContent={
                                                        <FontAwesomeIcon
                                                            icon={faGem}
                                                            className="text-white text-xs"
                                                        />
                                                    }
                                                    className="
                                                        h-8 px-4
                                                        bg-gradient-to-r from-emerald-500 to-green-500
                                                        hover:from-emerald-700 hover:to-green-700
                                                        active:scale-95
                                                        text-white text-xs font-semibold
                                                        shadow-sm hover:shadow-md
                                                        transition-all duration-200
                                                    "
                                                >
                                                    ADD ITEM
                                                </Button>
                                        }
                                        <h6 className="text-sm text-rose-700 font-semibold" >Total Items :
                                            {rows && rows.length > 0 ? rows.length : 0}</h6>

                                        {/* {selBillType == 'P' && isNewEntry && rows?.length>0&&
                                            <Checkbox size="sm"
                                                classNames={{ "label": "text-white " }}
                                                className="py-1 px-2 rounded-md bg-orange-600 border-0" label="gfu" color={"warning"} isSelected={isSameItem}
                                                onValueChange={(e) => handleChkSameItem(e)}>Same Item For All</Checkbox>} */}
                                    </div>

                                    {rows && rows.length > 0 ?

                                        <div className="flex items-center mt-1 w-full justify-end gap-4">
                                            <Input type="text" label="Conv Rate : " color="danger" variant="bordered"
                                                labelPlacement="outside-left" className="w-36 bg-white font-semibold"
                                                classNames={{ label: "font-semibold text-rose-700 uppercase" }}
                                                size="sm" placeholder="" value={selConvRate}
                                                onChange={(e) => handleConvRateChange(e)}
                                                onBlur={handleConvRateBlur}
                                            ></Input>

                                            <Input type="number" label="Disc % : " color="success" variant="bordered"
                                                labelPlacement="outside-left" className="w-28 bg-white font-semibold"
                                                classNames={{ label: "font-semibold text-rose-700 uppercase" }}
                                                size="sm" placeholder="" value={selDiscPer}
                                                onChange={(e) => handleDiscPerChange(e)} ></Input>

                                            <Input type="number" label="Rate ($) : " color="success" variant="bordered"
                                                labelPlacement="outside-left" className="w-32 bg-white font-semibold"
                                                classNames={{ label: "font-semibold text-rose-700 uppercase" }}
                                                size="sm" placeholder="" value={selDRate}
                                                onChange={(e) => handleDRateChange(e)} ></Input>
                                        </div> : ""}


                                </div>
                                {/* {isNewEntry && rows.length <= 0 ? "" :
                                    <div className="my-2">
                                        <Input type="text" size="sm"
                                            radius="none" placeholder="Search ...."
                                            startContent={<FontAwesomeIcon className="text-gray-700" icon={faSearchPlus}></FontAwesomeIcon>}
                                            variant="bordered" className="bg-white border-1 border-gray-300"
                                            value={searchText} onChange={(e) => setSearchText(e.target.value)}  ></Input>
                                    </div>} */}
                                {rows && rows?.length > 0 ? (
                                    <Box ref={gridContainerRef} sx={{ height: rows.length > 10 ? 400 : "auto", width: '100%' }}>
                                        <DataGrid
                                            rows={rows}
                                            columns={columns}
                                            editMode="row"
                                            apiRef={apiRef}
                                            columnHeaderHeight={30}
                                            rowHeight={45}
                                            disableRowSelectionOnClick
                                            disableColumnSorting={true}
                                            //disableColumnMenu={[] false}
                                            slots={{
                                                columnMenu: CustomColumnMenu,
                                            }}
                                            getRowClassName={(params) => {
                                                return 'row-class';
                                            }}
                                            sx={{

                                                '& .row-class': {
                                                    fontSize: "12px",
                                                },
                                                '& .sticky-row': {
                                                    position: 'sticky',
                                                    bottom: 0,
                                                    color: "#dd115c",
                                                    backgroundColor: '#FFFFFF',
                                                    zIndex: 10,
                                                    height: 30, margin: 0,
                                                    fontWeight: "bold",
                                                    fontSize: "12px"

                                                },
                                                '& .sticky-row:hover': {
                                                    backgroundColor: "#ffffff"
                                                },
                                                /* FORCE show column menu (3 dots) ALWAYS */
                                                '& .MuiDataGrid-columnHeaders': {
                                                    position: 'sticky',
                                                    top: 0,
                                                    fontWeight: "bold",
                                                    zIndex: 1, // Make sure the headers are above the rows when scrolling

                                                },
                                                '& .MuiDataGrid-menuIcon': {
                                                    visibility: 'visible',
                                                    opacity: 1,
                                                    width: 'auto',
                                                },
                                                // '& .MuiDataGrid-menuIcon button': {

                                                //     backgroundColor: "#ffffff",
                                                // },
                                                '& .MuiDataGrid-menuIcon svg': {
                                                    color: '#fffcfcff',

                                                },
                                            }}
                                            columnVisibilityModel={{
                                                [RowsField.itemCode]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.itemName]: setColumnVisiblity(RowsField.itemCode),
                                                [RowsField.lotNo]: setColumnVisiblity(RowsField.lotNo),
                                                [RowsField.pktNo]: setColumnVisiblity(RowsField.pktNo),
                                                [RowsField.shapeName]: setColumnVisiblity(RowsField.shapeCode),
                                                [RowsField.colorName]: setColumnVisiblity(RowsField.colorCode),
                                                [RowsField.purityName]: setColumnVisiblity(RowsField.purityCode),
                                                [RowsField.sizeName]: setColumnVisiblity(RowsField.sizeCode),
                                                [RowsField.lwRatio]: setColumnVisiblity(RowsField.lwRatio),
                                                [RowsField.reportNo]: setColumnVisiblity(RowsField.reportNo),
                                                [RowsField.lab]: setColumnVisiblity(RowsField.lab),
                                                [RowsField.itemDetail]: setColumnVisiblity(RowsField.itemDetail),
                                                [RowsField.rate]: setCurrencyColumnVisiblity(RowsField.rate),
                                                [RowsField.dRate]: setCurrencyColumnVisiblity(RowsField.dRate),
                                                [RowsField.amount]: setCurrencyColumnVisiblity(RowsField.amount),
                                                [RowsField.dAmount]: setCurrencyColumnVisiblity(RowsField.dAmount),
                                                [RowsField.convRate]: setCurrencyColumnVisiblity(RowsField.convRate),
                                                [RowsField.discAmtD]: setCurrencyColumnVisiblity(RowsField.discAmtD),
                                                [RowsField.netAmt]: setCurrencyColumnVisiblity(RowsField.netAmt),
                                                [RowsField.netAmtD]: setCurrencyColumnVisiblity(RowsField.netAmtD),

                                            }}

                                        />

                                    </Box>
                                ) : (
                                    <NoItemsCard />
                                )}
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="md"
                                    type="text"
                                    label="Brok %"
                                    placeholder="Brok %"
                                    value={brokPer}
                                    labelPlacement={"outside"}
                                    className="max-w-25"
                                    variant="flat"
                                    color="danger"
                                    onChange={(e) => funValidateNoInput(e.target.value) ? setBrokPer(e.target.value) : ""}
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">%</span>
                                        </div>
                                    }
                                />
                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar ? "" :
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Brok. Amt"
                                        placeholder="Brok. Amt"
                                        value={total_BrokAmt}
                                        className="max-w-25"
                                        labelPlacement={"outside"}
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                }
                                {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Brok. Amt($)"
                                        placeholder="Brok. Amt"
                                        value={total_BrokAmtD}
                                        className="max-w-25"
                                        labelPlacement={"outside"}
                                        variant="flat"
                                        color="danger"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">$</span>
                                            </div>
                                        }
                                    />
                                }
                            </div>
                            {/* ${isMobile ? "flex-wrap" : " gap-2 "} */}
                            <div className={` flex flex-wrap sm:flex-nowrap md:flex-nowrap gap-2  w-full`}>

                                <div className="flex  items-top gap-2 mt-7 w-full ">
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Disc Amount"
                                        placeholder="Disc Amount"
                                        labelPlacement={"outside"}
                                        value={parseFloat(disc_Amount ?? 0)}
                                        className="max-w-26"
                                        variant="flat"
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                        <Input
                                            size="md"
                                            type="number"
                                            label="Disc Amount($)"
                                            placeholder="Disc Amount($)"
                                            labelPlacement={"outside"}
                                            value={parseFloat(disc_AmountD ?? 0)}
                                            className="max-w-26"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">$</span>
                                                </div>
                                            }
                                        />}


                                </div>

                                <div className="flex  items-top gap-2 mt-7 w-full">
                                    <Input
                                        size="md"
                                        type="number"
                                        label="Net Amount"
                                        placeholder="Net Amount"
                                        labelPlacement={"outside"}
                                        value={Number(net_Amount ?? 0)}
                                        className="max-w-26"
                                        variant="flat"
                                        color="success"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        startContent={
                                            <div className="pointer-events-none flex items-center">
                                                <span className="text-default-400 text-small">₹</span>
                                            </div>
                                        }
                                    />
                                    {CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS ? "" :
                                        <Input
                                            size="md"
                                            type="number"
                                            label="Net Amount($)"
                                            placeholder="Net Amount($)"
                                            labelPlacement={"outside"}
                                            value={Number(net_AmountD ?? 0)}
                                            className="max-w-26"
                                            variant="flat"
                                            color="success"
                                            classNames={{
                                                label: "text-xs text-black font-bold",
                                            }}
                                            startContent={
                                                <div className="pointer-events-none flex items-center">
                                                    <span className="text-default-400 text-small">$</span>
                                                </div>
                                            }
                                        />}


                                </div>

                            </div>

                            <div className="flex  items-top gap-2 mt-7 w-full">
                                <Input
                                    size="md"
                                    type="number"
                                    label="CGST Tax"
                                    placeholder="CGSt"
                                    labelPlacement={"outside"}
                                    value={total_GSTtax}
                                    className="max-w-26"
                                    variant="flat"
                                    color="default"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                                <Input
                                    size="md"
                                    type="number"
                                    label="SGST Tax"
                                    placeholder="SGSt"
                                    labelPlacement={"outside"}
                                    value={total_SGSTtax}
                                    className="max-w-26"
                                    variant="flat"
                                    color="default"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                                <Input
                                    size="md"
                                    type="number"
                                    label="Total Tax"
                                    placeholder="Total Tax"
                                    labelPlacement={"outside"}
                                    value={parseFloat(total_SGSTtax) + parseFloat(total_GSTtax)}
                                    className="max-w-26"
                                    variant="flat"
                                    color="default"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Autocomplete
                                    size="md"
                                    name={"tdsAcId"}
                                    label={"TDS A/c."}
                                    eventResizeFeature={true}
                                    selectionMode="single"
                                    showScrollIndicators={true}
                                    labelPlacement={"outside"}
                                    placeholder={" "}
                                    isLoading={isLoadingData}
                                    menuTrigger={"input"}
                                    className="max-w-23"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    isClearable={false}
                                    isVirtualized
                                    color={"warning"}
                                    defaultItems={
                                        masterData && masterData?.acMaster ? masterData?.acMaster : []
                                    }
                                    onSelectionChange={setTdsAcId}
                                    selectedKey={tdsAcId}
                                >
                                    {(list) => (
                                        <AutocompleteItem

                                            key={list.Party_Id}
                                        >
                                            {list.Party_Name}
                                        </AutocompleteItem>
                                    )}
                                </Autocomplete>
                                <Input
                                    size="md"
                                    type="text"
                                    label="TDS %"
                                    placeholder="TDS %"
                                    value={tdsPer}
                                    labelPlacement={"outside"}
                                    className="max-w-25"
                                    variant="flat"
                                    color="warning"
                                    onChange={(e) => funValidateNoInput(e.target.value) ? setTdsPer(e.target.value) : ""}
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">%</span>
                                        </div>
                                    }
                                />

                                <Input
                                    size="md"
                                    type="number"
                                    label="TDS. Amt"
                                    placeholder="TDS. Amt"
                                    value={total_TDSAmt}
                                    className="max-w-25"
                                    labelPlacement={"outside"}
                                    variant="flat"
                                    color="warning"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    startContent={
                                        <div className="pointer-events-none flex items-center">
                                            <span className="text-default-400 text-small">₹</span>
                                        </div>
                                    }
                                />
                            </div>
                            <div className="flex  items-top gap-2 mt-7 ">
                                <Input
                                    size="sm"
                                    type="text"
                                    name={formField.dueDays}
                                    label="Due Days"
                                    placeholder="Due Days"
                                    value={formData[formField.dueDays]}
                                    className="max-w-25"
                                    classNames={{
                                        label: "text-xs text-black font-bold",
                                    }}
                                    variant="bordered"
                                    color="warning"
                                    onChange={(e) => funValidateNoInput(e.target.value) ? handleChange(e, formField.dueDays)
                                        : setFormData({ ...formData, [formField.dueDays]: 0 })}

                                />
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={"Due Date"}
                                        views={["day", "month", "year"]}
                                        format="DD/MM/YYYY"
                                        value={
                                            formData[formField.dueDate]
                                                ? dayjs(formData[formField.dueDate])
                                                : formData[formField.dueDate]
                                        }
                                        onChange={(newValue) => {
                                            setFormData((prev) => {
                                                return {
                                                    ...prev,
                                                    [formField.dueDate]:
                                                        dayjs(newValue).format("YYYY-MM-DD"),

                                                };
                                            });
                                        }}
                                        //isRequired={item.required}
                                        className="w-full "
                                        slotProps={{
                                            textField: { size: "small", required: false },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center  font-semibold flex items-center gap-4">
                                <Button
                                    id="btnsave"
                                    color="primary"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="bg-slate-900 uppercase font-semibold"
                                    isLoading={isPending}
                                    isDisabled={isDisableSubmit}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Save
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    isLoading={isPending}
                                    isDisabled={isDisableSubmit}
                                    className="text-white uppercase font-semibold"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                {selBillType == 'S' ?
                                    <Button
                                        id="btnSavePrint"
                                        color="primary"
                                        type="submit"
                                        size="sm"
                                        variant="shadow"
                                        className="uppercase font-semibold"
                                        isLoading={isPending}
                                        isDisabled={isDisableSubmit}
                                        startContent={<FontAwesomeIcon className=" text-md  text-slajte-900" icon={faPrint} />}
                                    >
                                        Save & Print
                                    </Button> : ""}
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    onPress={handleClickPrev}
                                    className="uppercase font-semibold"
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form >
                </Card >
            </MainContainer>
        </div >
    )

}
export default CreateInvoiceMaster

